export const ComparativeSales = {
  "sections": [
    // modified by Sir benedict caoili 
    {
      "columns": 12,
      "rows": 2,
      "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": "colorTheme1",
        "title": "Comparative Monthly Sales",
        "binding": {
          "data": {
            "columns": [
              {
                "name": 'Item Group',
                "columnName": 'ItemGroupCode',
                "width": '150px',
                "align": "left",
                "sortable": true,
                "sum": false
              },
              {
                "name": 'Jan',
                "columnName": 'Jan',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Feb',
                "columnName": 'Feb',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Mar',
                "columnName": 'Mar',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Apr',
                "columnName": 'Apr',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'May',
                "columnName": 'May',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Jun',
                "columnName": 'Jun',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Jul',
                "columnName": 'Jul',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Aug',
                "columnName": 'Aug',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Sep',
                "columnName": 'Sep',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Oct',
                "columnName": 'Oct',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Nov',
                "columnName": 'Nov',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Dec',
                "columnName": 'Dec',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Total Sales',
                "columnName": 'TotalSales',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              }
            ],
            "title": 'ItemGroupCode',
            "endpoint": "N49",
            "parameters": [
              { "key": "FromMonth", "value": "2024" },
              { "key": "FromYear", "value": "1" },
              { "key": "ToMonth", "value": "2024" },
              { "key": "ToYear", "value": "1" },
              { "key": "ConfigTypeCode", "value": "" }
            ]
          },
          "context": {
            "point": {
              "onClick": {
                "selectedValueColumn": "ItemGroupCode",
                "visuals": [
                  {
                    "title": "PESO",
                    "visual": [
                      {
                        "columns": 12,
                        "rows": 2,
                        "visual": {
                          "id": 1,
                          "type": "advancedTable",
                          "colorTheme": "colorTheme1",
                          "title": "PESO",
                          "binding": {
                            "data": {
                              "columns": [
                                {
                                  "name": 'Item Group',
                                  "columnName": 'ItemGroupCode',
                                  "width": '150px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'Jan',
                                  "columnName": 'Jan',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Feb',
                                  "columnName": 'Feb',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Mar',
                                  "columnName": 'Mar',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Apr',
                                  "columnName": 'Apr',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'May',
                                  "columnName": 'May',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Jun',
                                  "columnName": 'Jun',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Jul',
                                  "columnName": 'Jul',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Aug',
                                  "columnName": 'Aug',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Sep',
                                  "columnName": 'Sep',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Oct',
                                  "columnName": 'Oct',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Nov',
                                  "columnName": 'Nov',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Dec',
                                  "columnName": 'Dec',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Total Sales',
                                  "columnName": 'TotalSales',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                }
                              ],
                              "title": 'ItemGroupCode',
                              "endpoint": "N49.1",
                              "parameters": [
                                { "key": "FromMonth", "value": "2024" },
                                { "key": "FromYear", "value": "1" },
                                { "key": "ToMonth", "value": "2024" },
                                { "key": "ToYear", "value": "1" },
                                { "key": "ItemGroupCode", "value": "" },
                                { "key": "ConfigTypeCode", "value": "" }
                              ]
                            },
                            "context": {
                              "point": {
                                "onClick": {
                                  "selectedValueColumn": "ItemGroupCode",
                                  "visuals": [
                                    {
                                      "title": "Region",
                                      "visual": [
                                        {
                                          "columns": 12,
                                          "rows": 2,
                                          "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "Region",
                                            "binding": {
                                              "data": {
                                                "columns": [
                                                  {
                                                    "name": 'Region',
                                                    "columnName": 'RegionCode',
                                                    "width": '110px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                  },
                                                  {
                                                    "name": 'Jan',
                                                    "columnName": 'Jan',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Feb',
                                                    "columnName": 'Feb',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Mar',
                                                    "columnName": 'Mar',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Apr',
                                                    "columnName": 'Apr',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'May',
                                                    "columnName": 'May',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Jun',
                                                    "columnName": 'Jun',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Jul',
                                                    "columnName": 'Jul',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Aug',
                                                    "columnName": 'Aug',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Sep',
                                                    "columnName": 'Sep',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Oct',
                                                    "columnName": 'Oct',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Nov',
                                                    "columnName": 'Nov',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Dec',
                                                    "columnName": 'Dec',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Total Sales',
                                                    "columnName": 'TotalSales',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  }
                                                ],
                                                "title": 'RegionCode',
                                                "endpoint": "N49.3",
                                                "parameters": [
                                                  { "key": "FromMonth", "value": "2024" },
                                                  { "key": "FromYear", "value": "1" },
                                                  { "key": "ToMonth", "value": "2024" },
                                                  { "key": "ToYear", "value": "1" },
                                                  { "key": "ItemGroupCode", "value": "" },
                                                  { "key": "ConfigTypeCode", "value": "" }
                                                ]
                                              },
                                              "context": {
                                                "point": {
                                                  "onClick": {
                                                    "selectedValueColumn": "ItemGroupCodeRegionCode",
                                                    "selectedTitle": "Product",
                                                    "visual": [
                                                      {
                                                        "columns": 12,
                                                        "rows": 2,
                                                        "visual": {
                                                          "id": 1,
                                                          "type": "advancedTable",
                                                          "colorTheme": "colorTheme1",
                                                          "title": "Product",
                                                          "binding": {
                                                            "data": {
                                                              "columns": [
                                                                {
                                                                  "name": 'Item Name',
                                                                  "columnName": 'ItemName',
                                                                  "width": '200px',
                                                                  "align": "left",
                                                                  "sortable": true,
                                                                  "sum": false
                                                                },
                                                                {
                                                                  "name": 'Jan',
                                                                  "columnName": 'Jan',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Feb',
                                                                  "columnName": 'Feb',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Mar',
                                                                  "columnName": 'Mar',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Apr',
                                                                  "columnName": 'Apr',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'May',
                                                                  "columnName": 'May',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Jun',
                                                                  "columnName": 'Jun',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Jul',
                                                                  "columnName": 'Jul',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Aug',
                                                                  "columnName": 'Aug',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Sep',
                                                                  "columnName": 'Sep',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Oct',
                                                                  "columnName": 'Oct',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Nov',
                                                                  "columnName": 'Nov',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Dec',
                                                                  "columnName": 'Dec',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Total Sales',
                                                                  "columnName": 'TotalSales',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                }
                                                              ],
                                                              "title": 'ItemName',
                                                              "endpoint": "N49.7",
                                                              "parameters": [
                                                                { "key": "FromMonth", "value": "2024" },
                                                                { "key": "FromYear", "value": "1" },
                                                                { "key": "ToMonth", "value": "2024" },
                                                                { "key": "ToYear", "value": "1" },
                                                                { "key": "ItemGroupCodeRegionCode", "value": "" },
                                                                { "key": "ConfigTypeCode", "value": "" }
                                                              ]
                                                            },
                                                            "context": {
                                                              "point": {
                                                                "onClick": {

                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    ],
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "title": "District",
                                      "visual": [
                                        {
                                          "columns": 12,
                                          "rows": 2,
                                          "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "District",
                                            "binding": {
                                              "data": {
                                                "columns": [
                                                  {
                                                    "name": 'District Manager Name',
                                                    "columnName": 'DistrictManagerName',
                                                    "width": '200px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                  },
                                                  {
                                                    "name": 'District Name',
                                                    "columnName": 'DistrictName',
                                                    "width": '200px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                  },
                                                  {
                                                    "name": 'Region',
                                                    "columnName": 'RegionCode',
                                                    "width": '110px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                  },
                                                  {
                                                    "name": 'Jan',
                                                    "columnName": 'Jan',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Feb',
                                                    "columnName": 'Feb',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Mar',
                                                    "columnName": 'Mar',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Apr',
                                                    "columnName": 'Apr',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'May',
                                                    "columnName": 'May',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Jun',
                                                    "columnName": 'Jun',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Jul',
                                                    "columnName": 'Jul',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Aug',
                                                    "columnName": 'Aug',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Sep',
                                                    "columnName": 'Sep',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Oct',
                                                    "columnName": 'Oct',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Nov',
                                                    "columnName": 'Nov',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Dec',
                                                    "columnName": 'Dec',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Total Sales',
                                                    "columnName": 'TotalSales',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  }
                                                ],
                                                "title": 'DistrictManagerName',
                                                "endpoint": "N49.4",
                                                "parameters": [
                                                  { "key": "FromMonth", "value": "2024" },
                                                  { "key": "FromYear", "value": "1" },
                                                  { "key": "ToMonth", "value": "2024" },
                                                  { "key": "ToYear", "value": "1" },
                                                  { "key": "ItemGroupCode", "value": "" },
                                                  { "key": "ConfigTypeCode", "value": "" }
                                                ]
                                              },
                                              "context": {
                                                "point": {
                                                  "onClick": {
                                                    "selectedValueColumn": "ItemGroupCodeDistrictManagerNameDistrictRegion",
                                                    "selectedTitle": "Growth",
                                                    "visuals": [
                                                      {
                                                        "title": "Growth",
                                                        "visual": [
                                                          {
                                                            "columns": 12,
                                                            "rows": 2,
                                                            "visual": {
                                                              "id": 1,
                                                              "type": "advancedTable",
                                                              "colorTheme": "colorTheme1",
                                                              "title": "Growth and Performance",
                                                              "binding": {
                                                                "data": {
                                                                  "columns": [
                                                                    {
                                                                      "name": 'District Manager Name',
                                                                      "columnName": 'DistrictManagerName',
                                                                      "width": '200px',
                                                                      "align": "left",
                                                                      "sortable": true,
                                                                      "sum": false
                                                                    },
                                                                    {
                                                                      "name": 'District Name',
                                                                      "columnName": 'DistrictName',
                                                                      "width": '200px',
                                                                      "align": "left",
                                                                      "sortable": true,
                                                                      "sum": false
                                                                    },
                                                                    {
                                                                      "name": 'Region',
                                                                      "columnName": 'RegionCode',
                                                                      "width": '110px',
                                                                      "align": "left",
                                                                      "sortable": true,
                                                                      "sum": false
                                                                    },
                                                                    {
                                                                      "name": 'Actual Sales',
                                                                      "columnName": 'ActualSales',
                                                                      "width": '140px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true,
                                                                    },
                                                                    {
                                                                      "name": 'LY Sales',
                                                                      "columnName": 'LYSales',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true,
                                                                    },
                                                                    {
                                                                      "name": 'Growth %',
                                                                      "columnName": 'Growth',
                                                                      "width": '118px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": false,
                                                                      "percent": true
                                                                    },
                                                                    {
                                                                      "name": 'Target',
                                                                      "columnName": 'TargetSales',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true,
                                                                    },
                                                                    {
                                                                      "name": 'Performance %',
                                                                      "columnName": 'Performance',
                                                                      "width": '150px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": false,
                                                                      "percent": true
                                                                    }
                                                                  ],
                                                                  "title": 'ItemName',
                                                                  "endpoint": "N49.15",
                                                                  "parameters": [
                                                                    { "key": "FromMonth", "value": "2024" },
                                                                    { "key": "FromYear", "value": "1" },
                                                                    { "key": "ToMonth", "value": "2024" },
                                                                    { "key": "ToYear", "value": "1" },
                                                                    { "key": "ItemGroupCodeDistrictManagerNameDistrictRegion", "value": "" },
                                                                    { "key": "ConfigTypeCode", "value": "" }
                                                                  ]
                                                                },
                                                                "context": {
                                                                  "point": {
                                                                    "onClick": {

                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        ]
                                                      },
                                                      {
                                                        "title": "Product",
                                                        "visual": [
                                                          {
                                                            "columns": 12,
                                                            "rows": 2,
                                                            "visual": {
                                                              "id": 1,
                                                              "type": "advancedTable",
                                                              "colorTheme": "colorTheme1",
                                                              "title": "Product",
                                                              "binding": {
                                                                "data": {
                                                                  "columns": [
                                                                    {
                                                                      "name": 'Item Name',
                                                                      "columnName": 'ItemName',
                                                                      "width": '200px',
                                                                      "align": "left",
                                                                      "sortable": true,
                                                                      "sum": false
                                                                    },
                                                                    {
                                                                      "name": 'Jan',
                                                                      "columnName": 'Jan',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Feb',
                                                                      "columnName": 'Feb',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Mar',
                                                                      "columnName": 'Mar',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Apr',
                                                                      "columnName": 'Apr',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'May',
                                                                      "columnName": 'May',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Jun',
                                                                      "columnName": 'Jun',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Jul',
                                                                      "columnName": 'Jul',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Aug',
                                                                      "columnName": 'Aug',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Sep',
                                                                      "columnName": 'Sep',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Oct',
                                                                      "columnName": 'Oct',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Nov',
                                                                      "columnName": 'Nov',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Dec',
                                                                      "columnName": 'Dec',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Total Sales',
                                                                      "columnName": 'TotalSales',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    }
                                                                  ],
                                                                  "title": 'ItemName',
                                                                  "endpoint": "N49.9",
                                                                  "parameters": [
                                                                    { "key": "FromMonth", "value": "2024" },
                                                                    { "key": "FromYear", "value": "1" },
                                                                    { "key": "ToMonth", "value": "2024" },
                                                                    { "key": "ToYear", "value": "1" },
                                                                    { "key": "ItemGroupCodeDistrictManagerNameDistrictRegion", "value": "" },
                                                                    { "key": "ConfigTypeCode", "value": "" }
                                                                  ]
                                                                },
                                                                "context": {
                                                                  "point": {
                                                                    "onClick": {
                                                                      "selectedValueColumn": "ItemGroupCodeDistrictManagerNameDistrictRegionItem",
                                                                      "selectedTitle": "Product",
                                                                      "visual": [
                                                                        {
                                                                          "columns": 12,
                                                                          "rows": 2,
                                                                          "visual": {
                                                                            "id": 1,
                                                                            "type": "advancedTable",
                                                                            "colorTheme": "colorTheme1",
                                                                            "title": "Growth and Performance",
                                                                            "binding": {
                                                                              "data": {
                                                                                "columns": [
                                                                                  {
                                                                                    "name": 'Item Name',
                                                                                    "columnName": 'ItemName',
                                                                                    "width": '200px',
                                                                                    "align": "left",
                                                                                    "sortable": true,
                                                                                  },
                                                                                  {
                                                                                    "name": 'Actual Sales',
                                                                                    "columnName": 'ActualSales',
                                                                                    "width": '140px',
                                                                                    "align": "right",
                                                                                    "sortable": true,
                                                                                    "sum": true,
                                                                                  },
                                                                                  {
                                                                                    "name": 'LY Sales',
                                                                                    "columnName": 'LYSales',
                                                                                    "width": '125px',
                                                                                    "align": "right",
                                                                                    "sortable": true,
                                                                                    "sum": true,
                                                                                  },
                                                                                  {
                                                                                    "name": 'Growth %',
                                                                                    "columnName": 'Growth',
                                                                                    "width": '118px',
                                                                                    "align": "right",
                                                                                    "sortable": true,
                                                                                    "sum": false,
                                                                                    "percent": true
                                                                                  },
                                                                                  {
                                                                                    "name": 'Target',
                                                                                    "columnName": 'TargetSales',
                                                                                    "width": '125px',
                                                                                    "align": "right",
                                                                                    "sortable": true,
                                                                                    "sum": true,
                                                                                  },
                                                                                  {
                                                                                    "name": 'Performance %',
                                                                                    "columnName": 'Performance',
                                                                                    "width": '150px',
                                                                                    "align": "right",
                                                                                    "sortable": true,
                                                                                    "sum": false,
                                                                                    "percent": true
                                                                                  }
                                                                                ],
                                                                                "title": 'ItemName',
                                                                                "endpoint": "N49.21",
                                                                                "parameters": [
                                                                                  { "key": "FromMonth", "value": "2024" },
                                                                                  { "key": "FromYear", "value": "1" },
                                                                                  { "key": "ToMonth", "value": "2024" },
                                                                                  { "key": "ToYear", "value": "1" },
                                                                                  { "key": "ItemGroupCodeDistrictManagerNameDistrictRegionItem", "value": "" },
                                                                                  { "key": "ConfigTypeCode", "value": "" }
                                                                                ]
                                                                              },
                                                                              "context": {
                                                                                "point": {
                                                                                  "onClick": {

                                                                                  }
                                                                                }
                                                                              }
                                                                            }
                                                                          }
                                                                        }
                                                                      ]
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "title": "PMR",
                                      "visual": [
                                        {
                                          "columns": 12,
                                          "rows": 2,
                                          "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "PMR",
                                            "binding": {
                                              "data": {
                                                "columns": [
                                                  {
                                                    "name": 'PMR Code',
                                                    "columnName": 'AgentCode',
                                                    "width": '150px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                  },
                                                  {
                                                    "name": 'Employee Code',
                                                    "columnName": 'EmployeeCode',
                                                    "width": '150px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                  },
                                                  {
                                                    "name": 'PMR Name',
                                                    "columnName": 'AgentName',
                                                    "width": '200px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                  },
                                                  {
                                                    "name": 'Area Name',
                                                    "columnName": 'TerritoryName',
                                                    "width": '300px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                  },
                                                  {
                                                    "name": 'District Name',
                                                    "columnName": 'DistrictName',
                                                    "width": '150px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                  },
                                                  {
                                                    "name": 'Region',
                                                    "columnName": 'RegionCode',
                                                    "width": '110px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                  },
                                                  {
                                                    "name": 'Jan',
                                                    "columnName": 'Jan',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Feb',
                                                    "columnName": 'Feb',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Mar',
                                                    "columnName": 'Mar',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Apr',
                                                    "columnName": 'Apr',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'May',
                                                    "columnName": 'May',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Jun',
                                                    "columnName": 'Jun',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Jul',
                                                    "columnName": 'Jul',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Aug',
                                                    "columnName": 'Aug',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Sep',
                                                    "columnName": 'Sep',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Oct',
                                                    "columnName": 'Oct',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Nov',
                                                    "columnName": 'Nov',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Dec',
                                                    "columnName": 'Dec',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Total Sales',
                                                    "columnName": 'TotalSales',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  }
                                                ],
                                                "title": 'AgentName',
                                                "endpoint": "N49.11",
                                                "parameters": [
                                                  { "key": "FromMonth", "value": "2024" },
                                                  { "key": "FromYear", "value": "1" },
                                                  { "key": "ToMonth", "value": "2024" },
                                                  { "key": "ToYear", "value": "1" },
                                                  { "key": "ItemGroupCode", "value": "" },
                                                  { "key": "ConfigTypeCode", "value": "" }
                                                ]
                                              },
                                              "context": {
                                                "point": {
                                                  "onClick": {
                                                    "selectedValueColumn": "ItemGroupCodeAgentCodeTerritoryDistrictRegion",
                                                    "selectedTitle": "Product",
                                                    "visuals": [
                                                      {
                                                        "title": "Growth",
                                                        "visual": [
                                                          {
                                                            "columns": 12,
                                                            "rows": 2,
                                                            "visual": {
                                                              "id": 1,
                                                              "type": "advancedTable",
                                                              "colorTheme": "colorTheme1",
                                                              "title": "Growth and Performance",
                                                              "binding": {
                                                                "data": {
                                                                  "columns": [
                                                                    {
                                                                      "name": 'PMR Code',
                                                                      "columnName": 'AgentCode',
                                                                      "width": '170px',
                                                                      "align": "left",
                                                                      "sortable": true,
                                                                    },
                                                                    {
                                                                      "name": 'Employee Code',
                                                                      "columnName": 'EmployeeCode',
                                                                      "width": '170px',
                                                                      "align": "left",
                                                                      "sortable": true,
                                                                    },
                                                                    {
                                                                      "name": 'PMR Name',
                                                                      "columnName": 'AgentName',
                                                                      "width": '200px',
                                                                      "align": "left",
                                                                      "sortable": true,
                                                                    },
                                                                    {
                                                                      "name": 'Area Name',
                                                                      "columnName": 'TerritoryName',
                                                                      "width": '350px',
                                                                      "align": "left",
                                                                      "sortable": true,
                                                                    },
                                                                    {
                                                                      "name": 'District Name',
                                                                      "columnName": 'DistrictName',
                                                                      "width": '200px',
                                                                      "align": "left",
                                                                      "sortable": true,
                                                                    },
                                                                    {
                                                                      "name": 'Region',
                                                                      "columnName": 'RegionCode',
                                                                      "width": '110px',
                                                                      "align": "left",
                                                                      "sortable": true,
                                                                    },
                                                                    {
                                                                      "name": 'Actual Sales',
                                                                      "columnName": 'ActualSales',
                                                                      "width": '140px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true,
                                                                    },
                                                                    {
                                                                      "name": 'LY Sales',
                                                                      "columnName": 'LYSales',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true,
                                                                    },
                                                                    {
                                                                      "name": 'Growth %',
                                                                      "columnName": 'Growth',
                                                                      "width": '118px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": false,
                                                                      "percent": true
                                                                    },
                                                                    {
                                                                      "name": 'Target',
                                                                      "columnName": 'TargetSales',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true,
                                                                    },
                                                                    {
                                                                      "name": 'Performance %',
                                                                      "columnName": 'Performance',
                                                                      "width": '150px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": false,
                                                                      "percent": true
                                                                    }
                                                                  ],
                                                                  "title": 'ItemName',
                                                                  "endpoint": "N49.17",
                                                                  "parameters": [
                                                                    { "key": "FromMonth", "value": "2024" },
                                                                    { "key": "FromYear", "value": "1" },
                                                                    { "key": "ToMonth", "value": "2024" },
                                                                    { "key": "ToYear", "value": "1" },
                                                                    { "key": "ItemGroupCodeAgentCodeTerritoryDistrictRegion", "value": "" },
                                                                    { "key": "ConfigTypeCode", "value": "" }
                                                                  ]
                                                                },
                                                                "context": {
                                                                  "point": {
                                                                    "onClick": {

                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        ]

                                                      },
                                                      {
                                                        "title": "Product",
                                                        "visual": [
                                                          {
                                                            "columns": 12,
                                                            "rows": 2,
                                                            "visual": {
                                                              "id": 1,
                                                              "type": "advancedTable",
                                                              "colorTheme": "colorTheme1",
                                                              "title": "Product",
                                                              "binding": {
                                                                "data": {
                                                                  "columns": [
                                                                    {
                                                                      "name": 'Item Name',
                                                                      "columnName": 'ItemName',
                                                                      "width": '200px',
                                                                      "align": "left",
                                                                      "sortable": true,
                                                                      "sum": false
                                                                    },
                                                                    {
                                                                      "name": 'Jan',
                                                                      "columnName": 'Jan',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Feb',
                                                                      "columnName": 'Feb',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Mar',
                                                                      "columnName": 'Mar',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Apr',
                                                                      "columnName": 'Apr',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'May',
                                                                      "columnName": 'May',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Jun',
                                                                      "columnName": 'Jun',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Jul',
                                                                      "columnName": 'Jul',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Aug',
                                                                      "columnName": 'Aug',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Sep',
                                                                      "columnName": 'Sep',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Oct',
                                                                      "columnName": 'Oct',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Nov',
                                                                      "columnName": 'Nov',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Dec',
                                                                      "columnName": 'Dec',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    },
                                                                    {
                                                                      "name": 'Total Sales',
                                                                      "columnName": 'TotalSales',
                                                                      "width": '125px',
                                                                      "align": "right",
                                                                      "sortable": true,
                                                                      "sum": true
                                                                    }
                                                                  ],
                                                                  "title": 'ItemName',
                                                                  "endpoint": "N49.12",
                                                                  "parameters": [
                                                                    { "key": "FromMonth", "value": "2024" },
                                                                    { "key": "FromYear", "value": "1" },
                                                                    { "key": "ToMonth", "value": "2024" },
                                                                    { "key": "ToYear", "value": "1" },
                                                                    { "key": "ItemGroupCodeAgentCodeTerritoryDistrictRegion", "value": "" },
                                                                    { "key": "ConfigTypeCode", "value": "" }
                                                                  ]
                                                                },
                                                                "context": {
                                                                  "point": {
                                                                    "onClick": {
                                                                      "selectedValueColumn": "ItemGroupCodeAgentCodeTerritoryDistrictRegionItem",
                                                                      "selectedTitle": "Product",
                                                                      "visual": [
                                                                        {
                                                                          "columns": 12,
                                                                          "rows": 2,
                                                                          "visual": {
                                                                            "id": 1,
                                                                            "type": "advancedTable",
                                                                            "colorTheme": "colorTheme1",
                                                                            "title": "Growth and Performance",
                                                                            "binding": {
                                                                              "data": {
                                                                                "columns": [
                                                                                  {
                                                                                    "name": 'Item Name',
                                                                                    "columnName": 'ItemName',
                                                                                    "width": '200px',
                                                                                    "align": "left",
                                                                                    "sortable": true,
                                                                                  },
                                                                                  {
                                                                                    "name": 'Actual Sales',
                                                                                    "columnName": 'ActualSales',
                                                                                    "width": '140px',
                                                                                    "align": "right",
                                                                                    "sortable": true,
                                                                                    "sum": true,
                                                                                  },
                                                                                  {
                                                                                    "name": 'LY Sales',
                                                                                    "columnName": 'LYSales',
                                                                                    "width": '125px',
                                                                                    "align": "right",
                                                                                    "sortable": true,
                                                                                    "sum": true,
                                                                                  },
                                                                                  {
                                                                                    "name": 'Growth %',
                                                                                    "columnName": 'Growth',
                                                                                    "width": '118px',
                                                                                    "align": "right",
                                                                                    "sortable": true,
                                                                                    "sum": false,
                                                                                    "percent": true
                                                                                  },
                                                                                  {
                                                                                    "name": 'Target',
                                                                                    "columnName": 'TargetSales',
                                                                                    "width": '125px',
                                                                                    "align": "right",
                                                                                    "sortable": true,
                                                                                    "sum": true,
                                                                                  },
                                                                                  {
                                                                                    "name": 'Performance %',
                                                                                    "columnName": 'Performance',
                                                                                    "width": '150px',
                                                                                    "align": "right",
                                                                                    "sortable": true,
                                                                                    "sum": false,
                                                                                    "percent": true
                                                                                  }
                                                                                ],
                                                                                "title": 'ItemName',
                                                                                "endpoint": "N49.19",
                                                                                "parameters": [
                                                                                  { "key": "FromMonth", "value": "2024" },
                                                                                  { "key": "FromYear", "value": "1" },
                                                                                  { "key": "ToMonth", "value": "2024" },
                                                                                  { "key": "ToYear", "value": "1" },
                                                                                  { "key": "ItemGroupCodeAgentCodeTerritoryDistrictRegionItem", "value": "" },
                                                                                  { "key": "ConfigTypeCode", "value": "" }
                                                                                ]
                                                                              },
                                                                              "context": {
                                                                                "point": {
                                                                                  "onClick": {

                                                                                  }
                                                                                }
                                                                              }
                                                                            }
                                                                          }
                                                                        }
                                                                      ]
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      ]
                                    }
                                  ]
                                }
                              }
                            }
                          }
                        }
                      }
                    ]
                  },
                  {
                    "title": "UNIT",
                    "visual": [
                      {
                        "columns": 12,
                        "rows": 2,
                        "visual": {
                          "id": 1,
                          "type": "advancedTable",
                          "colorTheme": "colorTheme1",
                          "title": "UNIT",
                          "binding": {
                            "data": {
                              "columns": [
                                {
                                  "name": 'Item Group',
                                  "columnName": 'ItemGroupCode',
                                  "width": '150px',
                                  "align": "left",
                                  "sortable": true,
                                }
                              ],
                              "title": 'ItemGroupCode',
                              "endpoint": "N49.2",
                              "parameters": [
                                { "key": "FromMonth", "value": "2024" },
                                { "key": "FromYear", "value": "1" },
                                { "key": "ToMonth", "value": "2024" },
                                { "key": "ToYear", "value": "1" },
                                { "key": "ItemGroupCode", "value": "" },
                                { "key": "ConfigTypeCode", "value": "" }
                              ]
                            },
                            "context": {
                              "point": {
                                "onClick": {
                                  "selectedValueColumn": "ItemGroupCode",
                                  "visuals": [
                                    {
                                      "title": "Region",
                                      "visual": [
                                        {
                                          "columns": 12,
                                          "rows": 2,
                                          "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "Region",
                                            "binding": {
                                              "data": {
                                                "columns": [
                                                  {
                                                    "name": 'Region',
                                                    "columnName": 'RegionCode',
                                                    "width": '100px',
                                                    "align": "left",
                                                    "sortable": true,
                                                  }
                                                ],
                                                "title": 'RegionCode',
                                                "endpoint": "N49.5",
                                                "parameters": [
                                                  { "key": "FromMonth", "value": "2024" },
                                                  { "key": "FromYear", "value": "1" },
                                                  { "key": "ToMonth", "value": "2024" },
                                                  { "key": "ToYear", "value": "1" },
                                                  { "key": "ItemGroupCode", "value": "" },
                                                  { "key": "ConfigTypeCode", "value": "" }
                                                ]
                                              },
                                              "context": {
                                                "point": {
                                                  "onClick": {
                                                    "selectedValueColumn": "ItemGroupCodeRegionCode",
                                                    "selectedTitle": "Product",
                                                    "visual": [
                                                      {
                                                        "columns": 12,
                                                        "rows": 2,
                                                        "visual": {
                                                          "id": 1,
                                                          "type": "advancedTable",
                                                          "colorTheme": "colorTheme1",
                                                          "title": "Product",
                                                          "binding": {
                                                            "data": {
                                                              "columns": [
                                                                {
                                                                  "name": 'Item Name',
                                                                  "columnName": 'ItemName',
                                                                  "width": '200px',
                                                                  "align": "left",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Jan',
                                                                  "columnName": 'Jan',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Feb',
                                                                  "columnName": 'Feb',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Mar',
                                                                  "columnName": 'Mar',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Apr',
                                                                  "columnName": 'Apr',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'May',
                                                                  "columnName": 'May',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Jun',
                                                                  "columnName": 'Jun',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Jul',
                                                                  "columnName": 'Jul',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Aug',
                                                                  "columnName": 'Aug',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Sep',
                                                                  "columnName": 'Sep',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Oct',
                                                                  "columnName": 'Oct',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Nov',
                                                                  "columnName": 'Nov',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Dec',
                                                                  "columnName": 'Dec',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Total Sales',
                                                                  "columnName": 'TotalSales',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                }
                                                              ],
                                                              "title": 'ItemName',
                                                              "endpoint": "N49.8",
                                                              "parameters": [
                                                                { "key": "FromMonth", "value": "2024" },
                                                                { "key": "FromYear", "value": "1" },
                                                                { "key": "ToMonth", "value": "2024" },
                                                                { "key": "ToYear", "value": "1" },
                                                                { "key": "ItemGroupCodeRegionCode", "value": "" },
                                                                { "key": "ConfigTypeCode", "value": "" }
                                                              ]
                                                            },
                                                            "context": {
                                                              "point": {
                                                                "onClick": {

                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    ],
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "title": "District",
                                      "visual": [
                                        {
                                          "columns": 12,
                                          "rows": 2,
                                          "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "District",
                                            "binding": {
                                              "data": {
                                                "columns": [
                                                  {
                                                    "name": 'District Manager Name',
                                                    "columnName": 'DistrictManagerName',
                                                    "width": '200px',
                                                    "align": "left",
                                                    "sortable": true,
                                                  },
                                                  {
                                                    "name": 'District Name',
                                                    "columnName": 'DistrictName',
                                                    "width": '200px',
                                                    "align": "left",
                                                    "sortable": true,
                                                  },
                                                  {
                                                    "name": 'Region',
                                                    "columnName": 'RegionCode',
                                                    "width": '110px',
                                                    "align": "left",
                                                    "sortable": true,
                                                  }
                                                ],
                                                "title": 'DistrictManagerName',
                                                "endpoint": "N49.6",
                                                "parameters": [
                                                  { "key": "FromMonth", "value": "2024" },
                                                  { "key": "FromYear", "value": "1" },
                                                  { "key": "ToMonth", "value": "2024" },
                                                  { "key": "ToYear", "value": "1" },
                                                  { "key": "ItemGroupCode", "value": "" },
                                                  { "key": "ConfigTypeCode", "value": "" }
                                                ]
                                              },
                                              "context": {
                                                "point": {
                                                  "onClick": {
                                                    "selectedValueColumn": "ItemGroupCodeDistrictManagerNameDistrictRegion",
                                                    "selectedTitle": "Product",
                                                    "visual": [
                                                      {
                                                        "columns": 12,
                                                        "rows": 2,
                                                        "visual": {
                                                          "id": 1,
                                                          "type": "advancedTable",
                                                          "colorTheme": "colorTheme1",
                                                          "title": "Product",
                                                          "binding": {
                                                            "data": {
                                                              "columns": [
                                                                {
                                                                  "name": 'Item Name',
                                                                  "columnName": 'ItemName',
                                                                  "width": '200px',
                                                                  "align": "left",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Jan',
                                                                  "columnName": 'Jan',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Feb',
                                                                  "columnName": 'Feb',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Mar',
                                                                  "columnName": 'Mar',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Apr',
                                                                  "columnName": 'Apr',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'May',
                                                                  "columnName": 'May',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Jun',
                                                                  "columnName": 'Jun',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Jul',
                                                                  "columnName": 'Jul',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Aug',
                                                                  "columnName": 'Aug',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Sep',
                                                                  "columnName": 'Sep',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Oct',
                                                                  "columnName": 'Oct',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Nov',
                                                                  "columnName": 'Nov',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Dec',
                                                                  "columnName": 'Dec',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Total Sales',
                                                                  "columnName": 'TotalSales',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                }
                                                              ],
                                                              "title": 'ItemName',
                                                              "endpoint": "N49.10",
                                                              "parameters": [
                                                                { "key": "FromMonth", "value": "2024" },
                                                                { "key": "FromYear", "value": "1" },
                                                                { "key": "ToMonth", "value": "2024" },
                                                                { "key": "ToYear", "value": "1" },
                                                                { "key": "ItemGroupCodeDistrictManagerNameDistrictRegion", "value": "" },
                                                                { "key": "ConfigTypeCode", "value": "" }
                                                              ]
                                                            },
                                                            "context": {
                                                              "point": {
                                                                "onClick": {
                                                                  "selectedValueColumn": "ItemGroupCodeDistrictManagerNameDistrictRegionItem",
                                                                  "selectedTitle": "Product",
                                                                  "visual": [
                                                                    {
                                                                      "columns": 12,
                                                                      "rows": 2,
                                                                      "visual": {
                                                                        "id": 1,
                                                                        "type": "advancedTable",
                                                                        "colorTheme": "colorTheme1",
                                                                        "title": "Growth and Performance",
                                                                        "binding": {
                                                                          "data": {
                                                                            "columns": [
                                                                              {
                                                                                "name": 'Item Name',
                                                                                "columnName": 'ItemName',
                                                                                "width": '200px',
                                                                                "align": "left",
                                                                                "sortable": true,
                                                                              },
                                                                              {
                                                                                "name": 'Actual Sales',
                                                                                "columnName": 'ActualSales',
                                                                                "width": '140px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": true,
                                                                              },
                                                                              {
                                                                                "name": 'LY Sales',
                                                                                "columnName": 'LYSales',
                                                                                "width": '125px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": true,
                                                                              },
                                                                              {
                                                                                "name": 'Growth %',
                                                                                "columnName": 'Growth',
                                                                                "width": '118px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": false,
                                                                                "percent": true
                                                                              },
                                                                              {
                                                                                "name": 'Target',
                                                                                "columnName": 'TargetSales',
                                                                                "width": '125px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": true,
                                                                              },
                                                                              {
                                                                                "name": 'Performance %',
                                                                                "columnName": 'Performance',
                                                                                "width": '150px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": false,
                                                                                "percent": true
                                                                              }
                                                                            ],
                                                                            "title": 'ItemName',
                                                                            "endpoint": "N49.22",
                                                                            "parameters": [
                                                                              { "key": "FromMonth", "value": "2024" },
                                                                              { "key": "FromYear", "value": "1" },
                                                                              { "key": "ToMonth", "value": "2024" },
                                                                              { "key": "ToYear", "value": "1" },
                                                                              { "key": "ItemGroupCodeDistrictManagerNameDistrictRegionItem", "value": "" },
                                                                              { "key": "ConfigTypeCode", "value": "" }
                                                                            ]
                                                                          },
                                                                          "context": {
                                                                            "point": {
                                                                              "onClick": {

                                                                              }
                                                                            }
                                                                          }
                                                                        }
                                                                      }
                                                                    }
                                                                  ]
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    ]
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "title": "PMR",
                                      "visual": [
                                        {
                                          "columns": 12,
                                          "rows": 2,
                                          "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "PMR",
                                            "binding": {
                                              "data": {
                                                "columns": [
                                                  {
                                                    "name": 'PMR Code',
                                                    "columnName": 'AgentCode',
                                                    "width": '170px',
                                                    "align": "left",
                                                    "sortable": true,
                                                  },
                                                  {
                                                    "name": 'Employee Code',
                                                    "columnName": 'EmployeeCode',
                                                    "width": '170px',
                                                    "align": "left",
                                                    "sortable": true,
                                                  },
                                                  {
                                                    "name": 'PMR Name',
                                                    "columnName": 'AgentName',
                                                    "width": '200px',
                                                    "align": "left",
                                                    "sortable": true,
                                                  },
                                                  {
                                                    "name": 'Area Name',
                                                    "columnName": 'TerritoryName',
                                                    "width": '350px',
                                                    "align": "left",
                                                    "sortable": true,
                                                  },
                                                  {
                                                    "name": 'District Name',
                                                    "columnName": 'DistrictName',
                                                    "width": '200px',
                                                    "align": "left",
                                                    "sortable": true,
                                                  },
                                                  {
                                                    "name": 'Region',
                                                    "columnName": 'RegionCode',
                                                    "width": '110px',
                                                    "align": "left",
                                                    "sortable": true,
                                                  }
                                                ],
                                                "title": 'AgentName',
                                                "endpoint": "N49.13",
                                                "parameters": [
                                                  { "key": "FromMonth", "value": "2024" },
                                                  { "key": "FromYear", "value": "1" },
                                                  { "key": "ToMonth", "value": "2024" },
                                                  { "key": "ToYear", "value": "1" },
                                                  { "key": "ItemGroupCode", "value": "" },
                                                  { "key": "ConfigTypeCode", "value": "" }
                                                ]
                                              },
                                              "context": {
                                                "point": {
                                                  "onClick": {
                                                    "selectedValueColumn": "ItemGroupCodeAgentCodeTerritoryDistrictRegion",
                                                    "selectedTitle": "Product",
                                                    "visual": [
                                                      {
                                                        "columns": 12,
                                                        "rows": 2,
                                                        "visual": {
                                                          "id": 1,
                                                          "type": "advancedTable",
                                                          "colorTheme": "colorTheme1",
                                                          "title": "Product",
                                                          "binding": {
                                                            "data": {
                                                              "columns": [
                                                                {
                                                                  "name": 'Item Name',
                                                                  "columnName": 'ItemName',
                                                                  "width": '200px',
                                                                  "align": "left",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Jan',
                                                                  "columnName": 'Jan',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Feb',
                                                                  "columnName": 'Feb',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Mar',
                                                                  "columnName": 'Mar',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Apr',
                                                                  "columnName": 'Apr',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'May',
                                                                  "columnName": 'May',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Jun',
                                                                  "columnName": 'Jun',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Jul',
                                                                  "columnName": 'Jul',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Aug',
                                                                  "columnName": 'Aug',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Sep',
                                                                  "columnName": 'Sep',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Oct',
                                                                  "columnName": 'Oct',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Nov',
                                                                  "columnName": 'Nov',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Dec',
                                                                  "columnName": 'Dec',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Total Sales',
                                                                  "columnName": 'TotalSales',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                }
                                                              ],
                                                              "title": 'ItemName',
                                                              "endpoint": "N49.14",
                                                              "parameters": [
                                                                { "key": "FromMonth", "value": "2024" },
                                                                { "key": "FromYear", "value": "1" },
                                                                { "key": "ToMonth", "value": "2024" },
                                                                { "key": "ToYear", "value": "1" },
                                                                { "key": "ItemGroupCodeAgentCodeTerritoryDistrictRegion", "value": "" },
                                                                { "key": "ConfigTypeCode", "value": "" }
                                                              ]
                                                            },
                                                            "context": {
                                                              "point": {
                                                                "onClick": {
                                                                  "selectedValueColumn": "ItemGroupCodeAgentCodeTerritoryDistrictRegionItem",
                                                                  "selectedTitle": "Product",
                                                                  "visual": [
                                                                    {
                                                                      "columns": 12,
                                                                      "rows": 2,
                                                                      "visual": {
                                                                        "id": 1,
                                                                        "type": "advancedTable",
                                                                        "colorTheme": "colorTheme1",
                                                                        "title": "Growth and Performance",
                                                                        "binding": {
                                                                          "data": {
                                                                            "columns": [
                                                                              {
                                                                                "name": 'Item Name',
                                                                                "columnName": 'ItemName',
                                                                                "width": '200px',
                                                                                "align": "left",
                                                                                "sortable": true,
                                                                              },
                                                                              {
                                                                                "name": 'Actual Sales',
                                                                                "columnName": 'ActualSales',
                                                                                "width": '140px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": true,
                                                                              },
                                                                              {
                                                                                "name": 'LY Sales',
                                                                                "columnName": 'LYSales',
                                                                                "width": '125px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": true,
                                                                              },
                                                                              {
                                                                                "name": 'Growth %',
                                                                                "columnName": 'Growth',
                                                                                "width": '118px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": false,
                                                                                "percent": true
                                                                              },
                                                                              {
                                                                                "name": 'Target',
                                                                                "columnName": 'TargetSales',
                                                                                "width": '125px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": true,
                                                                              },
                                                                              {
                                                                                "name": 'Performance %',
                                                                                "columnName": 'Performance',
                                                                                "width": '150px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": false,
                                                                                "percent": true
                                                                              }
                                                                            ],
                                                                            "title": 'ItemName',
                                                                            "endpoint": "N49.20",
                                                                            "parameters": [
                                                                              { "key": "FromMonth", "value": "2024" },
                                                                              { "key": "FromYear", "value": "1" },
                                                                              { "key": "ToMonth", "value": "2024" },
                                                                              { "key": "ToYear", "value": "1" },
                                                                              { "key": "ItemGroupCodeAgentCodeTerritoryDistrictRegionItem", "value": "" },
                                                                              { "key": "ConfigTypeCode", "value": "" }
                                                                            ]
                                                                          },
                                                                          "context": {
                                                                            "point": {
                                                                              "onClick": {

                                                                              }
                                                                            }
                                                                          }
                                                                        }
                                                                      }
                                                                    }
                                                                  ]
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    ]
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      ]
                                    }
                                  ]
                                }
                              }
                            }
                          }
                        }
                      }
                    ]
                  }
                ]

              }
            }
          }
        }
      }
    },
    {
      "columns": 12,
      "rows": 2,
      "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": "colorTheme1",
        "title": "Comparative Monthly Sales (Drugstore Chains)",
        "binding": {
          "data": {
            "columns": [
              {
                "name": 'Principal Code',
                "columnName": 'DistributorCode',
                "width": '180px',
                "align": "left",
                "sortable": true,
                "sum": false
              },
              {
                "name": 'Jan',
                "columnName": 'Jan',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Feb',
                "columnName": 'Feb',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Mar',
                "columnName": 'Mar',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Apr',
                "columnName": 'Apr',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'May',
                "columnName": 'May',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Jun',
                "columnName": 'Jun',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Jul',
                "columnName": 'Jul',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Aug',
                "columnName": 'Aug',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Sep',
                "columnName": 'Sep',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Oct',
                "columnName": 'Oct',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Nov',
                "columnName": 'Nov',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Dec',
                "columnName": 'Dec',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Total Sales',
                "columnName": 'TotalSales',
                "width": '125px',
                "align": "right",
                "sortable": true,
                "sum": true
              }
            ],
            "title": 'DistributorCode',
            "endpoint": "N63",
            "parameters": [
              { "key": "FromMonth", "value": "2024" },
              { "key": "FromYear", "value": "1" },
              { "key": "ToMonth", "value": "2024" },
              { "key": "ToYear", "value": "1" },
              { "key": "ConfigTypeCode", "value": "" }
            ]
          },
          "context": {
            "point": {
              "onClick": {
                "selectedValueColumn": "DistributorCode",
                "visuals": [
                  {
                    "title": "PESO",
                    "visual": [
                      {
                        "columns": 12,
                        "rows": 2,
                        "visual": {
                          "id": 1,
                          "type": "advancedTable",
                          "colorTheme": "colorTheme1",
                          "title": "PESO",
                          "binding": {
                            "data": {
                              "columns": [
                                {
                                  "name": 'Principal Code',
                                  "columnName": 'DistributorCode',
                                  "width": '150px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'Jan',
                                  "columnName": 'Jan',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Feb',
                                  "columnName": 'Feb',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Mar',
                                  "columnName": 'Mar',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Apr',
                                  "columnName": 'Apr',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'May',
                                  "columnName": 'May',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Jun',
                                  "columnName": 'Jun',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Jul',
                                  "columnName": 'Jul',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Aug',
                                  "columnName": 'Aug',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Sep',
                                  "columnName": 'Sep',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Oct',
                                  "columnName": 'Oct',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Nov',
                                  "columnName": 'Nov',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Dec',
                                  "columnName": 'Dec',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Total Sales',
                                  "columnName": 'TotalSales',
                                  "width": '125px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                }
                              ],
                              "title": 'DistributorCode',
                              "endpoint": "N63.10",
                              "parameters": [
                                { "key": "FromMonth", "value": "2024" },
                                { "key": "FromYear", "value": "1" },
                                { "key": "ToMonth", "value": "2024" },
                                { "key": "ToYear", "value": "1" },
                                { "key": "DistributorCode", "value": "" },
                                { "key": "ConfigTypeCode", "value": "" }
                              ]
                            },
                            "context": {
                              "point": {
                                "onClick": {
                                  "selectedValueColumn": "DistributorCode",
                                  "visuals": [
                                    {
                                      "title": "Region",
                                      "visual": [
                                        {
                                          "columns": 12,
                                          "rows": 2,
                                          "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "Region",
                                            "binding": {
                                              "data": {
                                                "columns": [
                                                  {
                                                    "name": 'Region',
                                                    "columnName": 'RegionCode',
                                                    "width": '100px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                  },
                                                  {
                                                    "name": 'Jan',
                                                    "columnName": 'Jan',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Feb',
                                                    "columnName": 'Feb',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Mar',
                                                    "columnName": 'Mar',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Apr',
                                                    "columnName": 'Apr',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'May',
                                                    "columnName": 'May',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Jun',
                                                    "columnName": 'Jun',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Jul',
                                                    "columnName": 'Jul',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Aug',
                                                    "columnName": 'Aug',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Sep',
                                                    "columnName": 'Sep',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Oct',
                                                    "columnName": 'Oct',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Nov',
                                                    "columnName": 'Nov',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Dec',
                                                    "columnName": 'Dec',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Total Sales',
                                                    "columnName": 'TotalSales',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  }
                                                ],
                                                "title": 'RegionCode',
                                                "endpoint": "N63.1",
                                                "parameters": [
                                                  { "key": "FromMonth", "value": "2024" },
                                                  { "key": "FromYear", "value": "1" },
                                                  { "key": "ToMonth", "value": "2024" },
                                                  { "key": "ToYear", "value": "1" },
                                                  { "key": "DistributorCode", "value": "" },
                                                  { "key": "ConfigTypeCode", "value": "" }
                                                ]
                                              },
                                              "context": {
                                                "point": {
                                                  "onClick": {
                                                    "selectedValueColumn": "DistributorCodeRegionCode",
                                                    "selectedTitle": "Product",
                                                    "visual": [
                                                      {
                                                        "columns": 12,
                                                        "rows": 2,
                                                        "visual": {
                                                          "id": 1,
                                                          "type": "advancedTable",
                                                          "colorTheme": "colorTheme1",
                                                          "title": "Product",
                                                          "binding": {
                                                            "data": {
                                                              "columns": [
                                                                {
                                                                  "name": 'Item Name',
                                                                  "columnName": 'ItemName',
                                                                  "width": '200px',
                                                                  "align": "left",
                                                                  "sortable": true,
                                                                  "sum": false
                                                                },
                                                                {
                                                                  "name": 'Jan',
                                                                  "columnName": 'Jan',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Feb',
                                                                  "columnName": 'Feb',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Mar',
                                                                  "columnName": 'Mar',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Apr',
                                                                  "columnName": 'Apr',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'May',
                                                                  "columnName": 'May',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Jun',
                                                                  "columnName": 'Jun',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Jul',
                                                                  "columnName": 'Jul',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Aug',
                                                                  "columnName": 'Aug',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Sep',
                                                                  "columnName": 'Sep',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Oct',
                                                                  "columnName": 'Oct',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Nov',
                                                                  "columnName": 'Nov',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Dec',
                                                                  "columnName": 'Dec',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Total Sales',
                                                                  "columnName": 'TotalSales',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                }
                                                              ],
                                                              "title": 'ItemName',
                                                              "endpoint": "N63.4",
                                                              "parameters": [
                                                                { "key": "FromMonth", "value": "2024" },
                                                                { "key": "FromYear", "value": "1" },
                                                                { "key": "ToMonth", "value": "2024" },
                                                                { "key": "ToYear", "value": "1" },
                                                                { "key": "DistributorCodeRegionCode", "value": "" },
                                                                { "key": "ConfigTypeCode", "value": "" }
                                                              ]
                                                            },
                                                            "context": {
                                                              "point": {
                                                                "onClick": {

                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    ]
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "title": "District",
                                      "visual": [
                                        {
                                          "columns": 12,
                                          "rows": 2,
                                          "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "District",
                                            "binding": {
                                              "data": {
                                                "columns": [
                                                  {
                                                    "name": 'District Manager Name',
                                                    "columnName": 'DistrictManagerName',
                                                    "width": '200px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                  },
                                                  {
                                                    "name": 'District Name',
                                                    "columnName": 'DistrictName',
                                                    "width": '200px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                  },
                                                  {
                                                    "name": 'Region',
                                                    "columnName": 'RegionCode',
                                                    "width": '110px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                  },
                                                  {
                                                    "name": 'Jan',
                                                    "columnName": 'Jan',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Feb',
                                                    "columnName": 'Feb',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Mar',
                                                    "columnName": 'Mar',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Apr',
                                                    "columnName": 'Apr',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'May',
                                                    "columnName": 'May',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Jun',
                                                    "columnName": 'Jun',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Jul',
                                                    "columnName": 'Jul',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Aug',
                                                    "columnName": 'Aug',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Sep',
                                                    "columnName": 'Sep',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Oct',
                                                    "columnName": 'Oct',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Nov',
                                                    "columnName": 'Nov',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Dec',
                                                    "columnName": 'Dec',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Total Sales',
                                                    "columnName": 'TotalSales',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  }
                                                ],
                                                "title": 'DistrictManagerName',
                                                "endpoint": "N63.2",
                                                "parameters": [
                                                  { "key": "FromMonth", "value": "2024" },
                                                  { "key": "FromYear", "value": "1" },
                                                  { "key": "ToMonth", "value": "2024" },
                                                  { "key": "ToYear", "value": "1" },
                                                  { "key": "DistributorCode", "value": "" },
                                                  { "key": "ConfigTypeCode", "value": "" }
                                                ]
                                              },
                                              "context": {
                                                "point": {
                                                  "onClick": {
                                                    "selectedValueColumn": "DistributorCodeDistrictRegion",
                                                    "selectedTitle": "Product",
                                                    "visual": [
                                                      {
                                                        "columns": 12,
                                                        "rows": 2,
                                                        "visual": {
                                                          "id": 1,
                                                          "type": "advancedTable",
                                                          "colorTheme": "colorTheme1",
                                                          "title": "Product",
                                                          "binding": {
                                                            "data": {
                                                              "columns": [
                                                                {
                                                                  "name": 'Item Name',
                                                                  "columnName": 'ItemName',
                                                                  "width": '200px',
                                                                  "align": "left",
                                                                  "sortable": true,
                                                                  "sum": false
                                                                },
                                                                {
                                                                  "name": 'Jan',
                                                                  "columnName": 'Jan',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Feb',
                                                                  "columnName": 'Feb',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Mar',
                                                                  "columnName": 'Mar',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Apr',
                                                                  "columnName": 'Apr',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'May',
                                                                  "columnName": 'May',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Jun',
                                                                  "columnName": 'Jun',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Jul',
                                                                  "columnName": 'Jul',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Aug',
                                                                  "columnName": 'Aug',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Sep',
                                                                  "columnName": 'Sep',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Oct',
                                                                  "columnName": 'Oct',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Nov',
                                                                  "columnName": 'Nov',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Dec',
                                                                  "columnName": 'Dec',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Total Sales',
                                                                  "columnName": 'TotalSales',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                }
                                                              ],
                                                              "title": 'ItemName',
                                                              "endpoint": "N63.6",
                                                              "parameters": [
                                                                { "key": "FromMonth", "value": "2024" },
                                                                { "key": "FromYear", "value": "1" },
                                                                { "key": "ToMonth", "value": "2024" },
                                                                { "key": "ToYear", "value": "1" },
                                                                { "key": "DistributorCodeDistrictRegion", "value": "" },
                                                                { "key": "ConfigTypeCode", "value": "" }
                                                              ]
                                                            },
                                                            "context": {
                                                              "point": {
                                                                "onClick": {

                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    ]
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "title": "PMR",
                                      "visual": [
                                        {
                                          "columns": 12,
                                          "rows": 2,
                                          "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "PMR",
                                            "binding": {
                                              "data": {
                                                "columns": [
                                                  {
                                                    "name": 'PMR Code',
                                                    "columnName": 'AgentCode',
                                                    "width": '150px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                  },
                                                  {
                                                    "name": 'Employee Code',
                                                    "columnName": 'EmployeeCode',
                                                    "width": '150px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                  },
                                                  {
                                                    "name": 'PMR Name',
                                                    "columnName": 'AgentName',
                                                    "width": '200px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                  },
                                                  {
                                                    "name": 'Area Name',
                                                    "columnName": 'TerritoryName',
                                                    "width": '300px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                  },
                                                  {
                                                    "name": 'District Name',
                                                    "columnName": 'DistrictName',
                                                    "width": '150px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                  },
                                                  {
                                                    "name": 'Region',
                                                    "columnName": 'RegionCode',
                                                    "width": '110px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                  },
                                                  {
                                                    "name": 'Jan',
                                                    "columnName": 'Jan',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Feb',
                                                    "columnName": 'Feb',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Mar',
                                                    "columnName": 'Mar',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Apr',
                                                    "columnName": 'Apr',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'May',
                                                    "columnName": 'May',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Jun',
                                                    "columnName": 'Jun',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Jul',
                                                    "columnName": 'Jul',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Aug',
                                                    "columnName": 'Aug',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Sep',
                                                    "columnName": 'Sep',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Oct',
                                                    "columnName": 'Oct',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Nov',
                                                    "columnName": 'Nov',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Dec',
                                                    "columnName": 'Dec',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  },
                                                  {
                                                    "name": 'Total Sales',
                                                    "columnName": 'TotalSales',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                  }
                                                ],
                                                "title": 'AgentName',
                                                "endpoint": "N63.3",
                                                "parameters": [
                                                  { "key": "FromMonth", "value": "2024" },
                                                  { "key": "FromYear", "value": "1" },
                                                  { "key": "ToMonth", "value": "2024" },
                                                  { "key": "ToYear", "value": "1" },
                                                  { "key": "DistributorCode", "value": "" },
                                                  { "key": "ConfigTypeCode", "value": "" }
                                                ]
                                              },
                                              "context": {
                                                "point": {
                                                  "onClick": {
                                                    "selectedValueColumn": "DistributorCodeAgentCodeTerritoryDistrictRegion",
                                                    "selectedTitle": "Product",
                                                    "visual": [
                                                      {
                                                        "columns": 12,
                                                        "rows": 2,
                                                        "visual": {
                                                          "id": 1,
                                                          "type": "advancedTable",
                                                          "colorTheme": "colorTheme1",
                                                          "title": "Product",
                                                          "binding": {
                                                            "data": {
                                                              "columns": [
                                                                {
                                                                  "name": 'Item Name',
                                                                  "columnName": 'ItemName',
                                                                  "width": '200px',
                                                                  "align": "left",
                                                                  "sortable": true,
                                                                  "sum": false
                                                                },
                                                                {
                                                                  "name": 'Jan',
                                                                  "columnName": 'Jan',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Feb',
                                                                  "columnName": 'Feb',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Mar',
                                                                  "columnName": 'Mar',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Apr',
                                                                  "columnName": 'Apr',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'May',
                                                                  "columnName": 'May',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Jun',
                                                                  "columnName": 'Jun',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Jul',
                                                                  "columnName": 'Jul',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Aug',
                                                                  "columnName": 'Aug',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Sep',
                                                                  "columnName": 'Sep',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Oct',
                                                                  "columnName": 'Oct',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Nov',
                                                                  "columnName": 'Nov',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Dec',
                                                                  "columnName": 'Dec',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                },
                                                                {
                                                                  "name": 'Total Sales',
                                                                  "columnName": 'TotalSales',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                  "sum": true
                                                                }
                                                              ],
                                                              "title": 'ItemName',
                                                              "endpoint": "N63.8",
                                                              "parameters": [
                                                                { "key": "FromMonth", "value": "2024" },
                                                                { "key": "FromYear", "value": "1" },
                                                                { "key": "ToMonth", "value": "2024" },
                                                                { "key": "ToYear", "value": "1" },
                                                                { "key": "DistributorCodeAgentCodeTerritoryDistrictRegion", "value": "" },
                                                                { "key": "ConfigTypeCode", "value": "" }
                                                              ]
                                                            },
                                                            "context": {
                                                              "point": {
                                                                "onClick": {

                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    ]
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      ]
                                    }
                                  ]
                                }
                              }
                            }
                          }
                        }
                      }
                    ]
                  },
                  {
                    "title": "UNIT",
                    "visual": [
                      {
                        "columns": 12,
                        "rows": 2,
                        "visual": {
                          "id": 1,
                          "type": "advancedTable",
                          "colorTheme": "colorTheme1",
                          "title": "UNIT",
                          "binding": {
                            "data": {
                              "columns": [
                                {
                                  "name": 'Principal Code',
                                  "columnName": 'DistributorCode',
                                  "width": '180px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                }
                              ],
                              "title": 'DistributorCode',
                              "endpoint": "N63.11",
                              "parameters": [
                                { "key": "FromMonth", "value": "2024" },
                                { "key": "FromYear", "value": "1" },
                                { "key": "ToMonth", "value": "2024" },
                                { "key": "ToYear", "value": "1" },
                                { "key": "DistributorCode", "value": "" },
                                { "key": "ConfigTypeCode", "value": "" }
                              ]
                            },
                            "context": {
                              "point": {
                                "onClick": {
                                  "selectedValueColumn": "DistributorCode",
                                  "visuals": [
                                    {
                                      "title": "Region",
                                      "visual": [
                                        {
                                          "columns": 12,
                                          "rows": 2,
                                          "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "Region",
                                            "binding": {
                                              "data": {
                                                "columns": [
                                                  {
                                                    "name": 'Region',
                                                    "columnName": 'RegionCode',
                                                    "width": '100px',
                                                    "align": "left",
                                                    "sortable": true,
                                                  }
                                                ],
                                                "title": 'RegionCode',
                                                "endpoint": "N63.12",
                                                "parameters": [
                                                  { "key": "FromMonth", "value": "2024" },
                                                  { "key": "FromYear", "value": "1" },
                                                  { "key": "ToMonth", "value": "2024" },
                                                  { "key": "ToYear", "value": "1" },
                                                  { "key": "DistributorCode", "value": "" },
                                                  { "key": "ConfigTypeCode", "value": "" }
                                                ]
                                              },
                                              "context": {
                                                "point": {
                                                  "onClick": {
                                                    "selectedValueColumn": "DistributorCodeRegionCode",
                                                    "selectedTitle": "Product",
                                                    "visual": [
                                                      {
                                                        "columns": 12,
                                                        "rows": 2,
                                                        "visual": {
                                                          "id": 1,
                                                          "type": "advancedTable",
                                                          "colorTheme": "colorTheme1",
                                                          "title": "Product",
                                                          "binding": {
                                                            "data": {
                                                              "columns": [
                                                                {
                                                                  "name": 'Item Name',
                                                                  "columnName": 'ItemName',
                                                                  "width": '200px',
                                                                  "align": "left",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Jan',
                                                                  "columnName": 'Jan',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Feb',
                                                                  "columnName": 'Feb',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Mar',
                                                                  "columnName": 'Mar',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Apr',
                                                                  "columnName": 'Apr',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'May',
                                                                  "columnName": 'May',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Jun',
                                                                  "columnName": 'Jun',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Jul',
                                                                  "columnName": 'Jul',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Aug',
                                                                  "columnName": 'Aug',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Sep',
                                                                  "columnName": 'Sep',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Oct',
                                                                  "columnName": 'Oct',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Nov',
                                                                  "columnName": 'Nov',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Dec',
                                                                  "columnName": 'Dec',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Total Sales',
                                                                  "columnName": 'TotalSales',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                }
                                                              ],
                                                              "title": 'ItemName',
                                                              "endpoint": "N63.5",
                                                              "parameters": [
                                                                { "key": "FromMonth", "value": "2024" },
                                                                { "key": "FromYear", "value": "1" },
                                                                { "key": "ToMonth", "value": "2024" },
                                                                { "key": "ToYear", "value": "1" },
                                                                { "key": "DistributorCodeRegionCode", "value": "" },
                                                                { "key": "ConfigTypeCode", "value": "" }
                                                              ]
                                                            },
                                                            "context": {
                                                              "point": {
                                                                "onClick": {

                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    ]
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "title": "District",
                                      "visual": [
                                        {
                                          "columns": 12,
                                          "rows": 2,
                                          "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "District",
                                            "binding": {
                                              "data": {
                                                "columns": [
                                                  {
                                                    "name": 'District Manager Name',
                                                    "columnName": 'DistrictManagerName',
                                                    "width": '200px',
                                                    "align": "left",
                                                    "sortable": true,
                                                  },
                                                  {
                                                    "name": 'District Name',
                                                    "columnName": 'DistrictName',
                                                    "width": '200px',
                                                    "align": "left",
                                                    "sortable": true,
                                                  },
                                                  {
                                                    "name": 'Region',
                                                    "columnName": 'RegionCode',
                                                    "width": '110px',
                                                    "align": "left",
                                                    "sortable": true,
                                                  }
                                                ],
                                                "title": 'DistrictManagerName',
                                                "endpoint": "N63.13",
                                                "parameters": [
                                                  { "key": "FromMonth", "value": "2024" },
                                                  { "key": "FromYear", "value": "1" },
                                                  { "key": "ToMonth", "value": "2024" },
                                                  { "key": "ToYear", "value": "1" },
                                                  { "key": "DistributorCode", "value": "" },
                                                  { "key": "ConfigTypeCode", "value": "" }
                                                ]
                                              },
                                              "context": {
                                                "point": {
                                                  "onClick": {
                                                    "selectedValueColumn": "DistributorCodeDistrictRegion",
                                                    "selectedTitle": "Product",
                                                    "visual": [
                                                      {
                                                        "columns": 12,
                                                        "rows": 2,
                                                        "visual": {
                                                          "id": 1,
                                                          "type": "advancedTable",
                                                          "colorTheme": "colorTheme1",
                                                          "title": "Product",
                                                          "binding": {
                                                            "data": {
                                                              "columns": [
                                                                {
                                                                  "name": 'Item Name',
                                                                  "columnName": 'ItemName',
                                                                  "width": '200px',
                                                                  "align": "left",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Jan',
                                                                  "columnName": 'Jan',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Feb',
                                                                  "columnName": 'Feb',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Mar',
                                                                  "columnName": 'Mar',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Apr',
                                                                  "columnName": 'Apr',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'May',
                                                                  "columnName": 'May',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Jun',
                                                                  "columnName": 'Jun',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Jul',
                                                                  "columnName": 'Jul',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Aug',
                                                                  "columnName": 'Aug',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Sep',
                                                                  "columnName": 'Sep',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Oct',
                                                                  "columnName": 'Oct',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Nov',
                                                                  "columnName": 'Nov',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Dec',
                                                                  "columnName": 'Dec',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Total Sales',
                                                                  "columnName": 'TotalSales',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true
                                                                }
                                                              ],
                                                              "title": 'ItemName',
                                                              "endpoint": "N63.7",
                                                              "parameters": [
                                                                { "key": "FromMonth", "value": "2024" },
                                                                { "key": "FromYear", "value": "1" },
                                                                { "key": "ToMonth", "value": "2024" },
                                                                { "key": "ToYear", "value": "1" },
                                                                { "key": "DistributorCodeDistrictRegion", "value": "" },
                                                                { "key": "ConfigTypeCode", "value": "" }
                                                              ]
                                                            },
                                                            "context": {
                                                              "point": {
                                                                "onClick": {

                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    ]
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "title": "PMR",
                                      "visual": [
                                        {
                                          "columns": 12,
                                          "rows": 2,
                                          "visual": {
                                            "id": 1,
                                            "type": "advancedTable",
                                            "colorTheme": "colorTheme1",
                                            "title": "PMR",
                                            "binding": {
                                              "data": {
                                                "columns": [
                                                  {
                                                    "name": 'PMR Code',
                                                    "columnName": 'AgentCode',
                                                    "width": '170px',
                                                    "align": "left",
                                                    "sortable": true,
                                                  },
                                                  {
                                                    "name": 'Employee Code',
                                                    "columnName": 'EmployeeCode',
                                                    "width": '170px',
                                                    "align": "left",
                                                    "sortable": true,
                                                  },
                                                  {
                                                    "name": 'PMR Name',
                                                    "columnName": 'AgentName',
                                                    "width": '200px',
                                                    "align": "left",
                                                    "sortable": true,
                                                  },
                                                  {
                                                    "name": 'Area Name',
                                                    "columnName": 'TerritoryName',
                                                    "width": '350px',
                                                    "align": "left",
                                                    "sortable": true,
                                                  },
                                                  {
                                                    "name": 'District Name',
                                                    "columnName": 'DistrictName',
                                                    "width": '200px',
                                                    "align": "left",
                                                    "sortable": true,
                                                  },
                                                  {
                                                    "name": 'Region',
                                                    "columnName": 'RegionCode',
                                                    "width": '110px',
                                                    "align": "left",
                                                    "sortable": true,
                                                  }
                                                ],
                                                "title": 'AgentName',
                                                "endpoint": "N63.14",
                                                "parameters": [
                                                  { "key": "FromMonth", "value": "2024" },
                                                  { "key": "FromYear", "value": "1" },
                                                  { "key": "ToMonth", "value": "2024" },
                                                  { "key": "ToYear", "value": "1" },
                                                  { "key": "DistributorCode", "value": "" },
                                                  { "key": "ConfigTypeCode", "value": "" }
                                                ]
                                              },
                                              "context": {
                                                "point": {
                                                  "onClick": {
                                                    "selectedValueColumn": "DistributorCodeAgentCodeTerritoryDistrictRegion",
                                                    "selectedTitle": "Product",
                                                    "visual": [
                                                      {
                                                        "columns": 12,
                                                        "rows": 2,
                                                        "visual": {
                                                          "id": 1,
                                                          "type": "advancedTable",
                                                          "colorTheme": "colorTheme1",
                                                          "title": "Product",
                                                          "binding": {
                                                            "data": {
                                                              "columns": [
                                                                {
                                                                  "name": 'Item Name',
                                                                  "columnName": 'ItemName',
                                                                  "width": '200px',
                                                                  "align": "left",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Jan',
                                                                  "columnName": 'Jan',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Feb',
                                                                  "columnName": 'Feb',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Mar',
                                                                  "columnName": 'Mar',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Apr',
                                                                  "columnName": 'Apr',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'May',
                                                                  "columnName": 'May',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Jun',
                                                                  "columnName": 'Jun',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Jul',
                                                                  "columnName": 'Jul',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Aug',
                                                                  "columnName": 'Aug',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Sep',
                                                                  "columnName": 'Sep',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Oct',
                                                                  "columnName": 'Oct',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Nov',
                                                                  "columnName": 'Nov',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Dec',
                                                                  "columnName": 'Dec',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                },
                                                                {
                                                                  "name": 'Total Sales',
                                                                  "columnName": 'TotalSales',
                                                                  "width": '125px',
                                                                  "align": "right",
                                                                  "sortable": true,
                                                                }
                                                              ],
                                                              "title": 'ItemName',
                                                              "endpoint": "N63.9",
                                                              "parameters": [
                                                                { "key": "FromMonth", "value": "2024" },
                                                                { "key": "FromYear", "value": "1" },
                                                                { "key": "ToMonth", "value": "2024" },
                                                                { "key": "ToYear", "value": "1" },
                                                                { "key": "DistributorCodeAgentCodeTerritoryDistrictRegion", "value": "" },
                                                                { "key": "ConfigTypeCode", "value": "" }
                                                              ]
                                                            },
                                                            "context": {
                                                              "point": {
                                                                "onClick": {

                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    ]
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      ]
                                    }
                                  ]

                                }
                              }
                            }
                          }
                        }
                      }
                    ]
                  }
                ]
              }
            }
          }
        }
      }
    },
    {
      "columns": 12,
      "rows": 2,
      "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": "colorTheme1",
        "title": "Product Sales Growth & Performance",
        "binding": {
          "data": {
            "columns": [
              {
                "name": 'Item Name',
                "columnName": 'ItemName',
                "width": '250px',
                "align": "left",
                "sortable": true,
                "sum": false
              },
              {
                "name": 'Sales (PESO)',
                "columnName": 'ActualSales(Value)',
                "width": '140px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'LYSales (PESO)',
                "columnName": 'LYSales(Value)',
                "width": '150px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": '% Growth (PESO)',
                "columnName": 'Growth(Value)',
                "width": '170px',
                "align": "right",
                "sortable": true,
                "sum": false,
                "percent": true
              },
              {
                "name": 'Target (PESO)',
                "columnName": 'TargetSales(Value)',
                "width": '170px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": '% Performance (PESO)',
                "columnName": 'Performance(Value)',
                "width": '210px',
                "align": "right",
                "sortable": true,
                "sum": false,
                "percent": true
              },
              {
                "name": 'Sales (UNIT)',
                "columnName": 'ActualSales(Qty)',
                "width": '140px',
                "align": "right",
                "sortable": true
              },
              {
                "name": 'LYSales (UNIT)',
                "columnName": 'LYSales(Qty)',
                "width": '150px',
                "align": "right",
                "sortable": true
              },
              {
                "name": '% Growth (UNIT)',
                "columnName": 'Growth(Qty)',
                "width": '170px',
                "align": "right",
                "sortable": true,
                "sum": false,
                "percent": true
              },
              {
                "name": 'Target (UNIT)',
                "columnName": 'TargetSales(Qty)',
                "width": '170px',
                "align": "right",
                "sortable": true,
                "sum": false
              },
              {
                "name": '% Performance (UNIT)',
                "columnName": 'Performance(Qty)',
                "width": '210px',
                "align": "right",
                "sortable": true,
                "sum": false,
                "percent": true
              }
            ],
            "title": 'ItemName',
            "endpoint": "N42",
            "parameters": [
              { "key": "FromMonth", "value": "2024" },
              { "key": "FromYear", "value": "1" },
              { "key": "ToMonth", "value": "2024" },
              { "key": "ToYear", "value": "1" },
              { "key": "ConfigTypeCode", "value": "" }
            ]
          },
          "context": {
            "point": {
              "onClick": {
                "selectedValueColumn": "ItemName",
                "visuals": [
                  {
                    "title": "Region",
                    "visual": [
                      {
                        "columns": 12,
                        "rows": 2,
                        "visual": {
                          "id": 1,
                          "type": "advancedTable",
                          "colorTheme": "colorTheme1",
                          "title": "Region",
                          "binding": {
                            "data": {
                              "columns": [
                                {
                                  "name": 'Region',
                                  "columnName": 'RegionCode',
                                  "width": '250px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'Sales (PESO)',
                                  "columnName": 'ActualSales(Value)',
                                  "width": '140px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'LYSales (PESO)',
                                  "columnName": 'LYSales(Value)',
                                  "width": '150px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": '% Growth (PESO)',
                                  "columnName": 'Growth(Value)',
                                  "width": '170px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": false,
                                  "percent": true
                                },
                                {
                                  "name": 'Target (PESO)',
                                  "columnName": 'TargetSales(Value)',
                                  "width": '170px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": '% Performance (PESO)',
                                  "columnName": 'Performance(Value)',
                                  "width": '210px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": false,
                                  "percent": true
                                },
                                {
                                  "name": 'Sales (UNIT)',
                                  "columnName": 'ActualSales(Qty)',
                                  "width": '140px',
                                  "align": "right",
                                  "sortable": true
                                },
                                {
                                  "name": 'LYSales (UNIT)',
                                  "columnName": 'LYSales(Qty)',
                                  "width": '150px',
                                  "align": "right",
                                  "sortable": true
                                },
                                {
                                  "name": '% Growth (UNIT)',
                                  "columnName": 'Growth(Qty)',
                                  "width": '170px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": false,
                                  "percent": true
                                },
                                {
                                  "name": 'Target (UNIT)',
                                  "columnName": 'TargetSales(Qty)',
                                  "width": '170px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": '% Performance (UNIT)',
                                  "columnName": 'Performance(Qty)',
                                  "width": '210px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": false,
                                  "percent": true
                                }
                              ],
                              "title": 'RegionCode',
                              "endpoint": "N42.1",
                              "parameters": [
                                { "key": "FromMonth", "value": "2024" },
                                { "key": "FromYear", "value": "1" },
                                { "key": "ToMonth", "value": "2024" },
                                { "key": "ToYear", "value": "1" },
                                { "key": "ItemName", "value": "" },
                                { "key": "ConfigTypeCode", "value": "" }
                              ]
                            },
                            "context": {
                              "point": {
                                "onClick": {

                                }
                              }
                            }
                          }
                        }
                      }
                    ]
                  },
                  {
                    "title": "District",
                    "visual": [
                      {
                        "columns": 12,
                        "rows": 2,
                        "visual": {
                          "id": 1,
                          "type": "advancedTable",
                          "colorTheme": "colorTheme1",
                          "title": "District",
                          "binding": {
                            "data": {
                              "columns": [
                                {
                                  "name": 'District Manager Name',
                                  "columnName": 'DistrictManagerName',
                                  "width": '250px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'District Name',
                                  "columnName": 'DistrictName',
                                  "width": '250px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'Sales (PESO)',
                                  "columnName": 'ActualSales(Value)',
                                  "width": '140px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'LYSales (PESO)',
                                  "columnName": 'LYSales(Value)',
                                  "width": '150px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": '% Growth (PESO)',
                                  "columnName": 'Growth(Value)',
                                  "width": '170px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": false,
                                  "percent": true
                                },
                                {
                                  "name": 'Target (PESO)',
                                  "columnName": 'TargetSales(Value)',
                                  "width": '170px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": '% Performance (PESO)',
                                  "columnName": 'Performance(Value)',
                                  "width": '210px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": false,
                                  "percent": true
                                },
                                {
                                  "name": 'Sales (UNIT)',
                                  "columnName": 'ActualSales(Qty)',
                                  "width": '140px',
                                  "align": "right",
                                  "sortable": true
                                },
                                {
                                  "name": 'LYSales (UNIT)',
                                  "columnName": 'LYSales(Qty)',
                                  "width": '150px',
                                  "align": "right",
                                  "sortable": true
                                },
                                {
                                  "name": '% Growth (UNIT)',
                                  "columnName": 'Growth(Qty)',
                                  "width": '170px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": false,
                                  "percent": true
                                },
                                {
                                  "name": 'Target (UNIT)',
                                  "columnName": 'TargetSales(Qty)',
                                  "width": '170px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": '% Performance (UNIT)',
                                  "columnName": 'Performance(Qty)',
                                  "width": '210px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": false,
                                  "percent": true
                                }
                              ],
                              "title": 'DistrictManagerName',
                              "endpoint": "N42.2",
                              "parameters": [
                                { "key": "FromMonth", "value": "2024" },
                                { "key": "FromYear", "value": "1" },
                                { "key": "ToMonth", "value": "2024" },
                                { "key": "ToYear", "value": "1" },
                                { "key": "ItemName", "value": "" },
                                { "key": "ConfigTypeCode", "value": "" }
                              ]
                            },
                            "context": {
                              "point": {
                                "onClick": {

                                }
                              }
                            }
                          }
                        }
                      }
                    ]
                  },
                  {
                    "title": "PMR",
                    "visual": [
                      {
                        "columns": 12,
                        "rows": 2,
                        "visual": {
                          "id": 1,
                          "type": "advancedTable",
                          "colorTheme": "colorTheme1",
                          "title": "PMR",
                          "binding": {
                            "data": {
                              "columns": [
                                {
                                  "name": 'PMR Code',
                                  "columnName": 'AgentCode',
                                  "width": '200px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'Employee Code',
                                  "columnName": 'EmployeeCode',
                                  "width": '200px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'PMR Name',
                                  "columnName": 'AgentName',
                                  "width": '250px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'District Name',
                                  "columnName": 'DistrictName',
                                  "width": '250px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'Region',
                                  "columnName": 'RegionCode',
                                  "width": '200px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'Sales (PESO)',
                                  "columnName": 'ActualSales(Value)',
                                  "width": '140px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'LYSales (PESO)',
                                  "columnName": 'LYSales(Value)',
                                  "width": '150px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": '% Growth (PESO)',
                                  "columnName": 'Growth(Value)',
                                  "width": '170px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": false,
                                  "percent": true
                                },
                                {
                                  "name": 'Target (PESO)',
                                  "columnName": 'TargetSales(Value)',
                                  "width": '170px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": '% Performance (PESO)',
                                  "columnName": 'Performance(Value)',
                                  "width": '210px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": false,
                                  "percent": true
                                },
                                {
                                  "name": 'Sales (UNIT)',
                                  "columnName": 'ActualSales(Qty)',
                                  "width": '140px',
                                  "align": "right",
                                  "sortable": true
                                },
                                {
                                  "name": 'LYSales (UNIT)',
                                  "columnName": 'LYSales(Qty)',
                                  "width": '150px',
                                  "align": "right",
                                  "sortable": true
                                },
                                {
                                  "name": '% Growth (UNIT)',
                                  "columnName": 'Growth(Qty)',
                                  "width": '170px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": false,
                                  "percent": true
                                },
                                {
                                  "name": 'Target (UNIT)',
                                  "columnName": 'TargetSales(Qty)',
                                  "width": '170px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": '% Performance (UNIT)',
                                  "columnName": 'Performance(Qty)',
                                  "width": '210px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": false,
                                  "percent": true
                                }
                              ],
                              "title": 'AgentName',
                              "endpoint": "N42.3",
                              "parameters": [
                                { "key": "FromMonth", "value": "2024" },
                                { "key": "FromYear", "value": "1" },
                                { "key": "ToMonth", "value": "2024" },
                                { "key": "ToYear", "value": "1" },
                                { "key": "ItemName", "value": "" },
                                { "key": "ConfigTypeCode", "value": "" }
                              ]
                            },
                            "context": {
                              "point": {
                                "onClick": {

                                }
                              }
                            }
                          }
                        }
                      }
                    ]
                  }
                ]
              }
            }
          }
        }
      }
    },
    {
      "columns": 12,
      "rows": 2,
      "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": "colorTheme1",
        "title": "Product Sales by Channel (PESO)",
        "binding": {
          "data": {
            "columns": [
              {
                "name": 'Principal Code',
                "columnName": 'DistributorCode',
                "width": '150px',
                "align": "left",
                "sortable": true,
                "sum": false
              },
              {
                "name": 'Actual Sales',
                "columnName": 'ActualSales(Value)',
                "width": '140px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'LYSales',
                "columnName": 'LYSales(Value)',
                "width": '150px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Growth %',
                "columnName": 'Growth(Value)',
                "width": '150px',
                "align": "right",
                "sortable": true,
                "percent": true
              }

            ],
            "title": 'DistributorCode',
            "endpoint": "N64",
            "parameters": [
              { "key": "FromMonth", "value": "2024" },
              { "key": "FromYear", "value": "1" },
              { "key": "ToMonth", "value": "2024" },
              { "key": "ToYear", "value": "1" },
              { "key": "ConfigTypeCode", "value": "" }
            ]
          },
          "context": {
            "point": {
              "onClick": {
                "selectedValueColumn": "DistributorCode",
                "visuals": [
                  {
                    "title": "Region",
                    "visual": [
                      {
                        "columns": 12,
                        "rows": 2,
                        "visual": {
                          "id": 1,
                          "type": "advancedTable",
                          "colorTheme": "colorTheme1",
                          "title": "Region",
                          "binding": {
                            "data": {
                              "columns": [
                                {
                                  "name": 'Region',
                                  "columnName": 'RegionCode',
                                  "width": '100px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'Actual Sales',
                                  "columnName": 'ActualSales(Value)',
                                  "width": '140px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'LYSales',
                                  "columnName": 'LYSales(Value)',
                                  "width": '150px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Growth %',
                                  "columnName": 'Growth(Value)',
                                  "width": '150px',
                                  "align": "right",
                                  "sortable": true,
                                  "percent": true
                                }
                              ],
                              "title": 'RegionCode',
                              "endpoint": "N64.1",
                              "parameters": [
                                { "key": "FromMonth", "value": "2024" },
                                { "key": "FromYear", "value": "1" },
                                { "key": "ToMonth", "value": "2024" },
                                { "key": "ToYear", "value": "1" },
                                { "key": "DistributorCode", "value": "" },
                                { "key": "ConfigTypeCode", "value": "" }
                              ]
                            },
                            "context": {
                              "point": {
                                "onClick": {
                                  "selectedValueColumn": "DistributorCodeRegionCode",
                                  "selectedTitle": "Product",
                                  "visual": [
                                    {
                                      "columns": 12,
                                      "rows": 2,
                                      "visual": {
                                        "id": 1,
                                        "type": "advancedTable",
                                        "colorTheme": "colorTheme1",
                                        "title": "Product",
                                        "binding": {
                                          "data": {
                                            "columns": [
                                              {
                                                "name": 'Item Name',
                                                "columnName": 'ItemName',
                                                "width": '200px',
                                                "align": "left",
                                                "sortable": true,
                                                "sum": false
                                              },
                                              {
                                                "name": 'Sales (PESO)',
                                                "columnName": 'ActualSales(Value)',
                                                "width": '140px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": true
                                              },
                                              {
                                                "name": 'LYSales (PESO)',
                                                "columnName": 'LYSales(Value)',
                                                "width": '150px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": true
                                              },
                                              {
                                                "name": '% Growth (PESO)',
                                                "columnName": 'Growth(Value)',
                                                "width": '170px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": false,
                                                "percent": true
                                              },
                                              {
                                                "name": 'Sales (UNIT)',
                                                "columnName": 'ActualSales(Qty)',
                                                "width": '140px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": true
                                              },
                                              {
                                                "name": 'LYSales (UNIT)',
                                                "columnName": 'LYSales(Qty)',
                                                "width": '150px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": true
                                              },
                                              {
                                                "name": '% Growth (UNIT)',
                                                "columnName": 'Growth(Qty)',
                                                "width": '170px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": false,
                                                "percent": true
                                              }
                                            ],
                                            "title": 'ItemName',
                                            "endpoint": "N64.4",
                                            "parameters": [
                                              { "key": "FromMonth", "value": "2024" },
                                              { "key": "FromYear", "value": "1" },
                                              { "key": "ToMonth", "value": "2024" },
                                              { "key": "ToYear", "value": "1" },
                                              { "key": "ConfigTypeCode", "value": "" },
                                              { "key": "DistributorCodeRegionCode", "value": "" }
                                            ]
                                          },
                                          "context": {
                                            "point": {
                                              "onClick": {

                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  ]
                                }
                              }
                            }
                          }
                        }
                      }
                    ]
                  },
                  {
                    "title": "District",
                    "visual": [
                      {
                        "columns": 12,
                        "rows": 2,
                        "visual": {
                          "id": 1,
                          "type": "advancedTable",
                          "colorTheme": "colorTheme1",
                          "title": "District",
                          "binding": {
                            "data": {
                              "columns": [
                                {
                                  "name": 'District Manager Name',
                                  "columnName": 'DistrictManagerName',
                                  "width": '250px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'District Name',
                                  "columnName": 'DistrictName',
                                  "width": '200px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'Region',
                                  "columnName": 'RegionCode',
                                  "width": '100px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'Actual Sales',
                                  "columnName": 'ActualSales(Value)',
                                  "width": '140px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'LYSales',
                                  "columnName": 'LYSales(Value)',
                                  "width": '150px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Growth %',
                                  "columnName": 'Growth(Value)',
                                  "width": '150px',
                                  "align": "right",
                                  "sortable": true,
                                  "percent": true
                                }
                              ],
                              "title": 'DistrictManagerName',
                              "endpoint": "N64.2",
                              "parameters": [
                                { "key": "FromMonth", "value": "2024" },
                                { "key": "FromYear", "value": "1" },
                                { "key": "ToMonth", "value": "2024" },
                                { "key": "ToYear", "value": "1" },
                                { "key": "DistributorCode", "value": "" },
                                { "key": "ConfigTypeCode", "value": "" }
                              ]
                            },
                            "context": {
                              "point": {
                                "onClick": {
                                  "selectedValueColumn": "DistributorCodeRegionDistrict",
                                  "selectedTitle": "Product",
                                  "visual": [
                                    {
                                      "columns": 12,
                                      "rows": 2,
                                      "visual": {
                                        "id": 1,
                                        "type": "advancedTable",
                                        "colorTheme": "colorTheme1",
                                        "title": "Product",
                                        "binding": {
                                          "data": {
                                            "columns": [
                                              {
                                                "name": 'Item Name',
                                                "columnName": 'ItemName',
                                                "width": '200px',
                                                "align": "left",
                                                "sortable": true,
                                                "sum": false
                                              },
                                              {
                                                "name": 'Sales (PESO)',
                                                "columnName": 'ActualSales(Value)',
                                                "width": '140px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": true
                                              },
                                              {
                                                "name": 'LYSales (PESO)',
                                                "columnName": 'LYSales(Value)',
                                                "width": '150px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": true
                                              },
                                              {
                                                "name": '% Growth (PESO)',
                                                "columnName": 'Growth(Value)',
                                                "width": '170px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": false,
                                                "percent": true
                                              },
                                              {
                                                "name": 'Sales (UNIT)',
                                                "columnName": 'ActualSales(Qty)',
                                                "width": '140px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": true
                                              },
                                              {
                                                "name": 'LYSales (UNIT)',
                                                "columnName": 'LYSales(Qty)',
                                                "width": '150px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": true
                                              },
                                              {
                                                "name": '% Growth (UNIT)',
                                                "columnName": 'Growth(Qty)',
                                                "width": '170px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": false,
                                                "percent": true
                                              }
                                            ],
                                            "title": 'ItemName',
                                            "endpoint": "N64.5",
                                            "parameters": [
                                              { "key": "FromMonth", "value": "2024" },
                                              { "key": "FromYear", "value": "1" },
                                              { "key": "ToMonth", "value": "2024" },
                                              { "key": "ToYear", "value": "1" },
                                              { "key": "ConfigTypeCode", "value": "" },
                                              { "key": "DistributorCodeRegionDistrict", "value": "" }
                                            ]
                                          },
                                          "context": {
                                            "point": {
                                              "onClick": {

                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  ]
                                }
                              }
                            }
                          }
                        }
                      }
                    ]
                  },
                  {
                    "title": "PMR",
                    "visual": [
                      {
                        "columns": 12,
                        "rows": 2,
                        "visual": {
                          "id": 1,
                          "type": "advancedTable",
                          "colorTheme": "colorTheme1",
                          "title": "PMR",
                          "binding": {
                            "data": {
                              "columns": [
                                {
                                  "name": 'PMR Code',
                                  "columnName": 'AgentCode',
                                  "width": '150px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'Employee Code',
                                  "columnName": 'EmployeeCode',
                                  "width": '150px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'PMR Name',
                                  "columnName": 'AgentName',
                                  "width": '250px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'Area Name',
                                  "columnName": 'TerritoryName',
                                  "width": '300px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'District Name',
                                  "columnName": 'DistrictName',
                                  "width": '200px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'Region',
                                  "columnName": 'RegionCode',
                                  "width": '100px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'Actual Sales',
                                  "columnName": 'ActualSales(Value)',
                                  "width": '140px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'LYSales',
                                  "columnName": 'LYSales(Value)',
                                  "width": '150px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Growth %',
                                  "columnName": 'Growth(Value)',
                                  "width": '150px',
                                  "align": "right",
                                  "sortable": true,
                                  "percent": true
                                }
                              ],
                              "title": 'AgentName',
                              "endpoint": "N64.3",
                              "parameters": [
                                { "key": "FromMonth", "value": "2024" },
                                { "key": "FromYear", "value": "1" },
                                { "key": "ToMonth", "value": "2024" },
                                { "key": "ToYear", "value": "1" },
                                { "key": "DistributorCode", "value": "" },
                                { "key": "ConfigTypeCode", "value": "" }
                              ]
                            },
                            "context": {
                              "point": {
                                "onClick": {
                                  "selectedValueColumn": "DistributorCodeRegionDistrictAgent",
                                  "selectedTitle": "Product",
                                  "visual": [
                                    {
                                      "columns": 12,
                                      "rows": 2,
                                      "visual": {
                                        "id": 1,
                                        "type": "advancedTable",
                                        "colorTheme": "colorTheme1",
                                        "title": "Product",
                                        "binding": {
                                          "data": {
                                            "columns": [
                                              {
                                                "name": 'Item Name',
                                                "columnName": 'ItemName',
                                                "width": '200px',
                                                "align": "left",
                                                "sortable": true,
                                                "sum": false
                                              },
                                              {
                                                "name": 'Sales (PESO)',
                                                "columnName": 'ActualSales(Value)',
                                                "width": '140px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": true
                                              },
                                              {
                                                "name": 'LYSales (PESO)',
                                                "columnName": 'LYSales(Value)',
                                                "width": '150px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": true
                                              },
                                              {
                                                "name": '% Growth (PESO)',
                                                "columnName": 'Growth(Value)',
                                                "width": '170px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": false,
                                                "percent": true
                                              },
                                              {
                                                "name": 'Sales (UNIT)',
                                                "columnName": 'ActualSales(Qty)',
                                                "width": '140px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": true
                                              },
                                              {
                                                "name": 'LYSales (UNIT)',
                                                "columnName": 'LYSales(Qty)',
                                                "width": '150px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": true
                                              },
                                              {
                                                "name": '% Growth (UNIT)',
                                                "columnName": 'Growth(Qty)',
                                                "width": '170px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": false,
                                                "percent": true
                                              }
                                            ],
                                            "title": 'ItemName',
                                            "endpoint": "N64.6",
                                            "parameters": [
                                              { "key": "FromMonth", "value": "2024" },
                                              { "key": "FromYear", "value": "1" },
                                              { "key": "ToMonth", "value": "2024" },
                                              { "key": "ToYear", "value": "1" },
                                              { "key": "ConfigTypeCode", "value": "" },
                                              { "key": "DistributorCodeRegionDistrictAgent", "value": "" }
                                            ]
                                          },
                                          "context": {
                                            "point": {
                                              "onClick": {

                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  ]
                                }
                              }
                            }
                          }
                        }
                      }
                    ]
                  }
                ]
              }
            }
          }
        }
      }
    },
    {
      "columns": 12,
      "rows": 2,
      "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": "colorTheme1",
        "title": "Product Sales by Customer Group (PESO)",
        "binding": {
          "data": {
            "columns": [
              {
                "name": 'Customer Group',
                "columnName": 'CustomerGroup',
                "width": '250px',
                "align": "left",
                "sortable": true,
                "sum": false
              },
              {
                "name": 'Actual Sales',
                "columnName": 'ActualSales(Value)',
                "width": '140px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'LYSales',
                "columnName": 'LYSales(Value)',
                "width": '150px',
                "align": "right",
                "sortable": true,
                "sum": true
              },
              {
                "name": 'Growth %',
                "columnName": 'Growth(Value)',
                "width": '150px',
                "align": "right",
                "sortable": true,
                "percent": true
              }
            ],
            "title": 'CustomerGroup',
            "endpoint": "N65",
            "parameters": [
              { "key": "FromMonth", "value": "2024" },
              { "key": "FromYear", "value": "1" },
              { "key": "ToMonth", "value": "2024" },
              { "key": "ToYear", "value": "1" },
              { "key": "ConfigTypeCode", "value": "" }
            ]
          },
          "context": {
            "point": {
              "onClick": {
                "selectedValueColumn": 'CustomerGroup',
                "visuals": [
                  {
                    "title": "Region",
                    "visual": [
                      {
                        "columns": 12,
                        "rows": 2,
                        "visual": {
                          "id": 1,
                          "type": "advancedTable",
                          "colorTheme": "colorTheme1",
                          "title": "Region",
                          "binding": {
                            "data": {
                              "columns": [
                                {
                                  "name": 'Region',
                                  "columnName": 'RegionCode',
                                  "width": '150px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'Actual Sales',
                                  "columnName": 'ActualSales(Value)',
                                  "width": '140px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'LYSales',
                                  "columnName": 'LYSales(Value)',
                                  "width": '150px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Growth %',
                                  "columnName": 'Growth(Value)',
                                  "width": '150px',
                                  "align": "right",
                                  "sortable": true,
                                  "percent": true
                                }
                              ],
                              "title": 'RegionCode',
                              "endpoint": "N65.1",
                              "parameters": [
                                { "key": "FromMonth", "value": "2024" },
                                { "key": "FromYear", "value": "1" },
                                { "key": "ToMonth", "value": "2024" },
                                { "key": "ToYear", "value": "1" },
                                { "key": "CustomerGroup", "value": "" },
                                { "key": "ConfigTypeCode", "value": "" }
                              ]
                            },
                            "context": {
                              "point": {
                                "onClick": {
                                  "selectedValueColumn": "CustomerGroupRegionCode",
                                  "selectedTitle": "Product",
                                  "visual": [
                                    {
                                      "columns": 12,
                                      "rows": 2,
                                      "visual": {
                                        "id": 1,
                                        "type": "advancedTable",
                                        "colorTheme": "colorTheme1",
                                        "title": "Product",
                                        "binding": {
                                          "data": {
                                            "columns": [
                                              {
                                                "name": 'Item Name',
                                                "columnName": 'ItemName',
                                                "width": '150px',
                                                "align": "left",
                                                "sortable": true,
                                                "sum": false
                                              },
                                              {
                                                "name": 'Sales (PESO)',
                                                "columnName": 'ActualSales(Value)',
                                                "width": '140px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": true
                                              },
                                              {
                                                "name": 'LYSales (PESO)',
                                                "columnName": 'LYSales(Value)',
                                                "width": '150px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": true
                                              },
                                              {
                                                "name": '% Growth (PESO)',
                                                "columnName": 'Growth(Value)',
                                                "width": '170px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": false,
                                                "percent": true
                                              },
                                              {
                                                "name": 'Sales (UNIT)',
                                                "columnName": 'ActualSales(Qty)',
                                                "width": '140px',
                                                "align": "right",
                                                "sortable": true
                                              },
                                              {
                                                "name": 'LYSales (UNIT)',
                                                "columnName": 'LYSales(Qty)',
                                                "width": '150px',
                                                "align": "right",
                                                "sortable": true
                                              },
                                              {
                                                "name": '% Growth (UNIT)',
                                                "columnName": 'Growth(Qty)',
                                                "width": '170px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": false,
                                                "percent": true
                                              }
                                            ],
                                            "title": 'ItemName',
                                            "endpoint": "N65.4",
                                            "parameters": [
                                              { "key": "FromMonth", "value": "2024" },
                                              { "key": "FromYear", "value": "1" },
                                              { "key": "ToMonth", "value": "2024" },
                                              { "key": "ToYear", "value": "1" },
                                              { "key": "CustomerGroupRegionCode", "value": "" },
                                              { "key": "ConfigTypeCode", "value": "" }
                                            ]
                                          },
                                          "context": {
                                            "point": {
                                              "onClick": {

                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  ]
                                }
                              }
                            }
                          }
                        }
                      }
                    ]
                  },
                  {
                    "title": "District",
                    "visual": [
                      {
                        "columns": 12,
                        "rows": 2,
                        "visual": {
                          "id": 1,
                          "type": "advancedTable",
                          "colorTheme": "colorTheme1",
                          "title": "District",
                          "binding": {
                            "data": {
                              "columns": [
                                {
                                  "name": 'District Manager Name',
                                  "columnName": 'DistrictManagerName',
                                  "width": '250px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'District Name',
                                  "columnName": 'DistrictName',
                                  "width": '180px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'Region',
                                  "columnName": 'RegionCode',
                                  "width": '110px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'Actual Sales',
                                  "columnName": 'ActualSales(Value)',
                                  "width": '140px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'LYSales',
                                  "columnName": 'LYSales(Value)',
                                  "width": '150px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Growth %',
                                  "columnName": 'Growth(Value)',
                                  "width": '150px',
                                  "align": "right",
                                  "sortable": true,
                                  "percent": true
                                }
                              ],
                              "title": 'DistrictManagerName',
                              "endpoint": "N65.2",
                              "parameters": [
                                { "key": "FromMonth", "value": "2024" },
                                { "key": "FromYear", "value": "1" },
                                { "key": "ToMonth", "value": "2024" },
                                { "key": "ToYear", "value": "1" },
                                { "key": "CustomerGroup", "value": "" },
                                { "key": "ConfigTypeCode", "value": "" }
                              ]
                            },
                            "context": {
                              "point": {
                                "onClick": {
                                  "selectedValueColumn": "CustomerGroupDistrictRegion",
                                  "selectedTitle": "Product",
                                  "visual": [
                                    {
                                      "columns": 12,
                                      "rows": 2,
                                      "visual": {
                                        "id": 1,
                                        "type": "advancedTable",
                                        "colorTheme": "colorTheme1",
                                        "title": "Product",
                                        "binding": {
                                          "data": {
                                            "columns": [
                                              {
                                                "name": 'Item Name',
                                                "columnName": 'ItemName',
                                                "width": '150px',
                                                "align": "left",
                                                "sortable": true,
                                                "sum": false
                                              },
                                              {
                                                "name": 'Sales (PESO)',
                                                "columnName": 'ActualSales(Value)',
                                                "width": '140px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": true
                                              },
                                              {
                                                "name": 'LYSales (PESO)',
                                                "columnName": 'LYSales(Value)',
                                                "width": '150px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": true
                                              },
                                              {
                                                "name": '% Growth (PESO)',
                                                "columnName": 'Growth(Value)',
                                                "width": '170px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": false,
                                                "percent": true
                                              },
                                              {
                                                "name": 'Sales (UNIT)',
                                                "columnName": 'ActualSales(Qty)',
                                                "width": '140px',
                                                "align": "right",
                                                "sortable": true
                                              },
                                              {
                                                "name": 'LYSales (UNIT)',
                                                "columnName": 'LYSales(Qty)',
                                                "width": '150px',
                                                "align": "right",
                                                "sortable": true
                                              },
                                              {
                                                "name": '% Growth (UNIT)',
                                                "columnName": 'Growth(Qty)',
                                                "width": '170px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": false,
                                                "percent": true
                                              }
                                            ],
                                            "title": 'ItemName',
                                            "endpoint": "N65.5",
                                            "parameters": [
                                              { "key": "FromMonth", "value": "2024" },
                                              { "key": "FromYear", "value": "1" },
                                              { "key": "ToMonth", "value": "2024" },
                                              { "key": "ToYear", "value": "1" },
                                              { "key": "CustomerGroupDistrictRegion", "value": "" },
                                              { "key": "ConfigTypeCode", "value": "" }
                                            ]
                                          },
                                          "context": {
                                            "point": {
                                              "onClick": {

                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  ]
                                }
                              }
                            }
                          }
                        }
                      }
                    ]
                  },
                  {
                    "title": "PMR",
                    "visual": [
                      {
                        "columns": 12,
                        "rows": 2,
                        "visual": {
                          "id": 1,
                          "type": "advancedTable",
                          "colorTheme": "colorTheme1",
                          "title": "PMR",
                          "binding": {
                            "data": {
                              "columns": [
                                {
                                  "name": 'PMR Code',
                                  "columnName": 'AgentCode',
                                  "width": '150px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'Employee Code',
                                  "columnName": 'EmployeeCode',
                                  "width": '150px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'PMR Name',
                                  "columnName": 'AgentName',
                                  "width": '150px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'Area Name',
                                  "columnName": 'TerritoryName',
                                  "width": '300px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'District Name',
                                  "columnName": 'DistrictName',
                                  "width": '200px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'Region',
                                  "columnName": 'RegionCode',
                                  "width": '110px',
                                  "align": "left",
                                  "sortable": true,
                                  "sum": false
                                },
                                {
                                  "name": 'Actual Sales',
                                  "columnName": 'ActualSales(Value)',
                                  "width": '140px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'LYSales',
                                  "columnName": 'LYSales(Value)',
                                  "width": '150px',
                                  "align": "right",
                                  "sortable": true,
                                  "sum": true
                                },
                                {
                                  "name": 'Growth %',
                                  "columnName": 'Growth(Value)',
                                  "width": '150px',
                                  "align": "right",
                                  "sortable": true,
                                  "percent": true
                                }
                              ],
                              "title": 'AgentName',
                              "endpoint": "N65.3",
                              "parameters": [
                                { "key": "FromMonth", "value": "2024" },
                                { "key": "FromYear", "value": "1" },
                                { "key": "ToMonth", "value": "2024" },
                                { "key": "ToYear", "value": "1" },
                                { "key": "CustomerGroup", "value": "" },
                                { "key": "ConfigTypeCode", "value": "" }
                              ]
                            },
                            "context": {
                              "point": {
                                "onClick": {
                                  "selectedValueColumn": "CustomerGroupAgentDistrictRegion",
                                  "selectedTitle": "Product",
                                  "visual": [
                                    {
                                      "columns": 12,
                                      "rows": 2,
                                      "visual": {
                                        "id": 1,
                                        "type": "advancedTable",
                                        "colorTheme": "colorTheme1",
                                        "title": "Product",
                                        "binding": {
                                          "data": {
                                            "columns": [
                                              {
                                                "name": 'Item Name',
                                                "columnName": 'ItemName',
                                                "width": '150px',
                                                "align": "left",
                                                "sortable": true,
                                                "sum": false
                                              },
                                              {
                                                "name": 'Sales (PESO)',
                                                "columnName": 'ActualSales(Value)',
                                                "width": '140px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": true
                                              },
                                              {
                                                "name": 'LYSales (PESO)',
                                                "columnName": 'LYSales(Value)',
                                                "width": '150px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": true
                                              },
                                              {
                                                "name": '% Growth (PESO)',
                                                "columnName": 'Growth(Value)',
                                                "width": '170px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": false,
                                                "percent": true
                                              },
                                              {
                                                "name": 'Sales (UNIT)',
                                                "columnName": 'ActualSales(Qty)',
                                                "width": '140px',
                                                "align": "right",
                                                "sortable": true
                                              },
                                              {
                                                "name": 'LYSales (UNIT)',
                                                "columnName": 'LYSales(Qty)',
                                                "width": '150px',
                                                "align": "right",
                                                "sortable": true
                                              },
                                              {
                                                "name": '% Growth (UNIT)',
                                                "columnName": 'Growth(Qty)',
                                                "width": '170px',
                                                "align": "right",
                                                "sortable": true,
                                                "sum": false,
                                                "percent": true
                                              }
                                            ],
                                            "title": 'ItemName',
                                            "endpoint": "N65.6",
                                            "parameters": [
                                              { "key": "FromMonth", "value": "2024" },
                                              { "key": "FromYear", "value": "1" },
                                              { "key": "ToMonth", "value": "2024" },
                                              { "key": "ToYear", "value": "1" },
                                              { "key": "CustomerGroupAgentDistrictRegion", "value": "" },
                                              { "key": "ConfigTypeCode", "value": "" }
                                            ]
                                          },
                                          "context": {
                                            "point": {
                                              "onClick": {

                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  ]
                                }
                              }
                            }
                          }
                        }
                      }
                    ]
                  }
                ]
              }
            }
          }
        }
      }
    }
  ]
}
